<template>
    <section v-if="$can('read','boolean_search')">
        <!-- <h4>Search Candidates</h4> -->
        <b-row>
            <b-col>
                <b-card>
                <b-row>
                    <b-col md="12" lg="12" sm="12">
                        <h5 class="float-left text-primary">
                            What Position are you searching for?
                        </h5>
                        <b-form-input 
                            id="boolean-search"
                            type="text"
                            placeholder="Enter Job Id of the position in format SHJ-2000"
                            v-model="filter.jobId"
                            style="height: 40px"
                            
                        />
                    </b-col>
                    <b-col md="12" lg="12" sm="12" class="mt-1">
                        <b-input-group>
                        
                        <b-form-input v-if="isBoolean"
                            id="boolean-search"
                            type="text"
                            placeholder="Enter Boolean Search keyword"
                            v-model="filter.booleanSearchString"
                            style="height: 45px"
                            @input="isValidBooleanSearch(booleanSearchString)"
                        /> 
                        
                        <v-select v-if="!isBoolean"
                            v-model="filter.selected"
                            placeholder="select or type keyword and press enter" 
                            taggable
                            push-tags
                            label="keyword"
                            style="width: 90%; "
                            multiple
                            :options="skillOptions"
                            :close-on-select="false"
                            class="vs__selected-neutral"
                            
                        >
                        <!-- <template #option="{ label, isMandatory}">
                            <span :class="{ 'favourite': isMandatory}">{{ label }}</span>
                        </template> -->

                        <template #selected-option="{ keyword, isMandatory, isExcluded}">
                            <span :class=" isMandatory ? 'favourite': isExcluded ? 'text-danger' : '' ">
                                <span style="font-size: 12px" @click="toggleFavourite(keyword)">
                                    <feather-icon
                                        icon="StarIcon"
                                        size="18"
                                        class="align-middle mr-25"
                                        :class="{ 'favourite': isMandatory}"
                                    />
                                </span>
                                <span style="font-size: 12px" @click="toggleExclude(keyword)">
                                    <feather-icon
                                        icon="MinusIcon"
                                        size="18"
                                        class="align-middle mr-25"
                                        :class="{ 'text-danger': isExcluded}"
                                    />
                                </span>
                            <span> {{ keyword }}</span></span>
                        </template>
                        </v-select>
                        <b-input-group-append>
                        
                        <!-- <div style="padding-left: 10px">
                            
                            <b-form-checkbox
                                
                                class="custom-control-info"
                                name="check-button"
                                v-model="filter.isBoolean"
                                switch
                            />
                            <b-card-text class="mb-0">
                                Boolean
                            </b-card-text>
                            </div> -->
                        </b-input-group-append>
                        </b-input-group>
                        <small v-if="!filter.isValidBoolean && filter.booleanSearchString" class="text-danger">Please Enter Valid Boolean String</small>
                        <!-- <div v-if="!isBoolean && keywords">
                            <small class="text-secondary">Mark Keywords as Mandatory</small>
                            <b-form-group label="Choose the Status" label-for="vue-select">
                            <li 
                            style="display: inline-flex; margin: 5px; padding: 2px"
                            v-for="(key,index) in keywords"
                            :key="index"
                            >
                            <b-badge
                                style="color: black !important"
                                variant="light"
                                :id="status.text"
                                @click="makeMandatory(key.text)"
                                >{{ key.text }}</b-badge
                            >
                            </li>
                        </b-form-group>
                        </div> -->
                    </b-col>
                    
                    <b-col sm="6" md="4" lg="4" class="mt-1">
                        <strong>Experience in years</strong>
                        <b-row>
                            <b-col md="6" xl="6" xs="6" class="mb-1">
                            <b-form-group
                                label="Min"
                                label-for="min-exp">
                                <v-select
                                    v-model="filter.minExp"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="min-exp"
                                    placeholder="min exp"
                                    :options="experiences"
                                />
                            </b-form-group>
                            </b-col>
                            <b-col md="6" xl="6" xs="6" class="mb-1">
                            <b-form-group
                                label="Max"
                                label-for="max-exp">
                                <v-select
                                    v-model="filter.maxExp"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="max-exp"
                                    placeholder="max exp"
                                    :options="experiences"
                                />
                                <small v-if="filter.minExp && filter.maxExp <= filter.minExp" class="text-danger">Max Exp cannot be less than Min Exp</small>
                            </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" md="4" lg="4" class="mt-1">
                        <strong>CTC in Lakhs</strong>
                        <b-row>
                            <b-col md="6" xl="6" xs="6" class="mb-1">
                            <b-form-group
                                label="Min"
                                label-for="min-exp">
                                <v-select
                                    v-model="filter.minCTC"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="min-ctc"
                                    placeholder="min ctc"
                                    :options="ctcOptions"
                                />
                            </b-form-group>
                            </b-col>
                            <b-col md="6" xl="6" xs="6" class="mb-1">
                                <b-form-group
                                label="Max"
                                label-for="max-exp">
                                <v-select
                                    v-model="filter.maxCTC"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="max-ctc"
                                    placeholder="max ctc"
                                    :options="ctcOptions"
                                />
                                <small v-if="filter.maxCTC < filter.minCTC" class="text-danger">Max CTC cannot be less than Min CTC</small>
                            </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                    
                    <b-col sm="6" md="4" lg="4" class="mt-1">
                        <strong>Notice Period</strong>
                        <b-row>
                            <b-col md="12">
                                <b-form-group>
                                <b-form-radio-group
                                    v-model="filter.noticePeriod"
                                    :options="noticePeriodOptions"
                                    name="radios-stacked"
                                    class="demo-inline-spacing"
                                />
                            </b-form-group>
                        </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" md="4" lg="4" class="mt-1">
                        <strong>Location</strong>
                        <b-row>
                            <b-col md="12">
                                <b-form-group
                                label-for="max-exp">
                                <v-select
                                    v-model="filter.locations"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="title"
                                    :options="citiesOptions"
                                    :reduce="(option) => option.title"
                                    placeholder="Select Current/Pref Locations"
                                    multiple
                                    :close-on-select="false"
                                />
                            </b-form-group>
                        </b-col>
                        </b-row>
                        
                    </b-col>
                    <b-col sm="6" md="4" lg="4" class="mt-1">
                        <strong>Qualification</strong>
                        <b-row>
                            <b-col md="12">
                                <b-form-group>
                                <v-select
                                    v-model="filter.qualifications"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="title"
                                    placeholder="Select Qualifications"
                                    :options="qualificationOptions"
                                    :reduce="(option) => option.title"
                                    multiple
                                    :close-on-select="false"
                                />
                            </b-form-group>
                        </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" md="4" lg="4" class="mt-1">
                        <strong>Gender</strong>
                        <b-row>
                            <b-col md="12">
                                <b-form-group>
                                <v-select
                                    v-model="filter.genders"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="title"
                                    placeholder="Select Gender"
                                    :options="genderOptions"
                                    :reduce="(option) => option.title"
                                    multiple
                                    :close-on-select="false"
                                />
                            </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" md="3" lg="3" class="mt-1">
                        <strong>Source </strong>
                        <b-row>
                            <b-col md="12">
                                <b-form-group>
                                <v-select
                                    v-model="filter.source"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="title"
                                    placeholder="Select Source"
                                    :options="sourceOptions"
                                    :reduce="(option) => option.title"
                                    multiple
                                    :close-on-select="false"
                                />
                            </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                    <!-- <b-col sm="6" md="6" lg="6" class="mt-1">
                        <strong>Exclude Recently Joined</strong>
                        <b-row>
                            <b-col md="12">
                                <b-form-group>
                                    <b-form-radio-group
                                    v-model="excludeJoined"
                                    :options="joinedOptions"
                                    name="radios-stacked"
                                    class="demo-inline-spacing"
                                />
                            </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col> -->
                    
                    <b-col sm="6" md="3" lg="3" class="mt-1">
                        <strong>Company </strong>
                        <b-row>
                            <b-col md="12">
                                <b-form-group>
                                <b-form-input
                                    v-model="filter.company"
                                    placeholder="Companies perferred"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                />
                            </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                    
                    <b-col sm="6" md="3" lg="3" class="mt-1">
                        <strong>Role </strong>
                        <b-row>
                            <b-col md="12">
                                <b-form-group>
                                <b-form-input
                                    v-model="filter.role"
                                    placeholder="Role perferred"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                />
                            </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                    
                    <b-col sm="6" md="3" lg="3" class="mt-1">
                        <strong>Exclude Company </strong>
                        <b-row>
                            <b-col md="12">
                                <b-form-group>
                                <b-form-input
                                    v-model="filter.excludeCompany"
                                    placeholder="companies not perferred"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                />
                            </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                    <!-- <b-col sm="6" md="3" lg="3" class="mt-1">
                        <strong>Exclude Status </strong>
                        <b-row>
                            <b-col md="12">
                                <b-form-group>
                                <v-select
                                    v-model="filter.status"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="title"
                                    placeholder="Select status to exclude"
                                    :options="statusOptions"
                                    :reduce="(option) => option.title"
                                    multiple
                                    :close-on-select="false"
                                />
                            </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>  -->

                </b-row>                    
                <div class="text-center mt-1">
                    <b-button variant="primary" style="width: 300px;" @click="searchDB" v-if="$can('read','boolean_search')">
                        Search !
                    </b-button>
                    <span class="mx-1" @click="clearFilter"><u>Clear Filter</u></span>
                    <span class="mx-1" v-ripple.400="'rgba(113, 102, 240, 0.15)'" v-if="$can('create','search')" 
                            v-b-modal.modal-save-search><u>Save Search</u></span>
                </div>
                
            </b-card>
            </b-col>
        </b-row>
        
        <b-row v-if="$can('read','boolean_search')">
            <b-col v-if="candidates.length > 0 && keywordsMatchCount > 1"  md="12" lg="12" sm="12" class="mb-1">
                <div class="text-info text-center font-weight-bolder"> Search Keywords matching Job description : {{ keywordsMatchCount }} </div>    
            </b-col>
            <b-col v-if="candidates.length > 0 && keywordsMatchCount <= 1" md="12" lg="12" sm="12" class="mb-1">
                <div class="text-danger text-center font-weight-bolder"> Search Keywords matching Job description : {{ keywordsMatchCount }}, please check Job Id again </div>    
            </b-col>
            <b-col v-if="error"  md="8" lg="8" sm="8">
                <div  class="text-danger text-center font-weight-bolder"> {{ error }}</div>    
            </b-col>
            <b-col v-else  md="8" lg="8" sm="8">
                <div v-if="loading" class="text-center">
                    Fetching Candidates please wait ........
                    <b-spinner label="Loading..." />
                </div>
                <div class="d-flex justify-content-end mb-1" v-if="candidates.length > 0">
                    <b-button-group>
                        <b-button 
                            variant="outline-primary" 
                            size="sm"
                            @click="downloadExcel"
                            
                        >
                            <feather-icon icon="DownloadIcon" size="14" class="mr-1"/>
                            Download Excel
                        </b-button>
                        <b-input-group>
                            <b-form-input
                                v-model="jobFilterSearch"
                                placeholder="Search by job ID"
                                @keyup.enter="filterByJob(jobFilterSearch)"
                            />
                            <b-input-group-append>
                                <b-button 
                                    variant="outline-primary"
                                    @click="filterByJob(jobFilterSearch)"
                                >
                                    <feather-icon icon="SearchIcon" size="14" class="mr-1"/>
                                    Search
                                </b-button>
                                <b-button 
                                    variant="outline-secondary"
                                    @click="clearJobFilter"
                                >
                                    <feather-icon icon="XIcon" size="14" class="mr-1"/>
                                    Clear
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-button-group>
                </div>
                <div class="row text-center mb-1" style="justify-content: center;" v-else>
                    Pages : 
                    <b-pagination
                    v-model="filter.currentPage"
                    :total-rows="this.totalCount"
                    :per-page="filter.perPage"
                    aria-controls="candidate-list"
                    @change="changePage"
                ></b-pagination>
                </div>
                <div class="container d-flex justify-content-between" v-if="candidates"> 
                    <strong class="item">
                        <span class="mb-0 px-5 text-success" >
                            <!-- <b-button @click="selectAllItems"> -->
                                <!-- <b-form-checkbox :v-model="selectAll" @change="selectAllItems">Select All</b-form-checkbox> -->
                             <!-- </b-button> -->
                            <b-button @click="selectAll" class="btn-can-db" variant="outline-primary" v-if="totalCount > 0">Select All</b-button>
                            <b-button @click="deselectAll" class="btn-can-db" variant="outline-primary" v-if="selectedCandidates.length > 0">Deselect All</b-button>
                        </span>
                    </strong>
                    <span class="item " style="margin-top: 8px !important;"> <strong v-if="totalCount"> Matched: {{ totalCount }}</strong></span>
                    <span class="item" style="margin-top: 8px !important;"><label for="filter.perPage">Aging:</label>
                    <select v-model="agingSelected" @change="filterAging()" id="aging" v-if="totalCount > 0">
                        <option value="15">15 days</option>
                        <option value="30">1 Month</option>
                        <option value="60">2 Months</option>
                        <option value="90">3 Months</option>
                        <option value="180">6 Months</option>
                    </select></span>
                    <span class="item" style="margin-top: 8px !important;" v-if="totalCount > 0"><label for="filter.perPage">per page:</label>
                    <select v-model="filter.perPage" @change="changePage(filter.currentPage)" id="filter.perPage">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="150">150</option>
                        <option value="500">500</option>
                    </select></span>
                    <b-dropdown class="item" v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="link"
                        toggle-class="text-decoration-none"
                        no-caret
                        right
                        v-if="selectedCandidates.length > 0 && keywordsMatchCount >= 2">
                        <template v-slot:button-content>
                            <feather-icon
                            icon="MoreVerticalIcon"
                            size="16"
                            class="text-body align-middle mr-25"
                            />
                        </template>
                        <b-dropdown-item v-if="$can('read','mass_mailer')"
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'" 
                            @click="openMassMailerModal"
                            >
                            Mass Mail
                        </b-dropdown-item>
                        <!-- <b-dropdown-item v-if="userRole !== 'TALENT-ADVISOR-SOURCER' && userRole !== 'TALENT-ADVISOR'" -->
                        <b-dropdown-item v-if="$can('manage','bulk_assign')"
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'" 
                            v-b-modal.modal-assign-to-job>
                            Assign to Job
                        </b-dropdown-item>
                        <!-- <b-dropdown-item>Update</b-dropdown-item> -->
                    </b-dropdown>
                </div>
                
                <b-card v-for="(candidate, index) in candidates" :key="index">
                <!-- <b-card v-for="candidate in candidates" :key="candidate.id"> -->

                    <div style="padding-bottom:0px; ">

                        
                        <div class="d-flex justify-content-between">
                            <b-form-checkbox class="mt-0 item" :id ="'selectAllBtn_' + candidate._source.id" v-model="selectedCandidates" :options="candidates" :value="candidate._source.id" checked @change="toggleSelection(candidate._source.id)"/>
                           
                    <!-- Candidate Name and Last Accessed -->
                            <router-link :to="{ path: '/apps/candidates/view/' + candidate._source.id + '/' + null, params: { id: candidate._source.candidate_id } }">
                                <h4 class="mb-0 text-primary mt-0 item text-left" >{{ candidate._source.candidate_id  }} - {{ candidate._source.first_name + ' ' + candidate._source.last_name }} <small class="text-small"> (Match Score: {{ candidate._score }})</small></h4>
                                
                            </router-link>    
                    
                            <span class="px-2 text-primary mt-0 item" @click="previewCV(candidate._source.cv_path)">CV<feather-icon
                                        icon="DownloadIcon"
                                        size="15"
                            />  </span>
                            <span class="px-2 text-primary mt-0 item" v-if="$can('read','boolean_search')">
                                <b-dropdown class="item" v-ripple.400="'rgba(0, 207, 232, 0.15)'"
                                    text="Info"
                                    variant="flat-info"
                                    v-if="keywordsMatchCount >= 2"
                                    >
                                    <template v-slot:button-content>
                                        <u>more</u>
                                    </template>
                                    <b-dropdown-item v-if="$can('update','candidate_status')"
                                        v-ripple.400="'rgba(113, 102, 240, 0.15)'" 
                                        @click="shareProfile(candidate._source.id, job.id)"
                                        >
                                        <feather-icon
                                        icon="Share2Icon"
                                        size="15"
                                        /> Share Profile
                                    </b-dropdown-item>
                                    <b-dropdown-item v-if="$can('update','candidate_status')"
                                        v-ripple.400="'rgba(113, 102, 240, 0.15)'" 
                                        @click="showNINRModal('ni',candidate._source.id)">
                                        Not Interested
                                    </b-dropdown-item>
                                    <b-dropdown-item v-if="$can('update','candidate_status')"
                                        v-ripple.400="'rgba(113, 102, 240, 0.15)'" 
                                        @click="showNINRModal('nr',candidate._source.id)">
                                        Not Relevant
                                    </b-dropdown-item>
                                    <b-dropdown-item v-if="$can('update','candidate_status')"
                                        v-ripple.400="'rgba(113, 102, 240, 0.15)'" 

                                        @click="showNotAnsweredModal(candidate._source.id)">
                                        Not Answered
                                    </b-dropdown-item>
                                    <!-- <b-dropdown-item>Update</b-dropdown-item> -->
                                </b-dropdown>
                            </span>

                            <!-- <span class="px-2 text-primary mt-0 item" @click="shareProfile(candidate._source.id, job.id)"><feather-icon
                                        icon="Share2Icon"
                                        size="15"
                            />  </span> -->
                        </div>
                        
                        <!-- <b-form-checkbox v-model="candidate.isChecked" :value="candidate.id" @change="toggleSelection(candidate.id, candidate.isChecked)" v-if="!selectAll"/>
                        <b-form-checkbox v-model="selectAll" v-else/> -->
                                
                        </div>
                    <div class="d-flex px-1" style="padding-top:15px;">
                        <small>
                            <span class="px-2"> <feather-icon
                                icon="BriefcaseIcon"
                                size="15"
                            /> {{ candidate._source.exp  }} Can be: ({{ candidate._source.tentative_exp }})
                            </span>
                            <span> <strong style="font-size: 14px">₹ </strong> {{ candidate._source.ctc }}
                            </span>
                            <span class="px-2"> <feather-icon
                                icon="MapPinIcon"
                                size="15"
                            /> {{ candidate._source.curr_location }}
                            </span>
                            <span class="px-2 text-primary" ><b><u><a :href="'mailto:' + candidate._source.email"> <feather-icon
                                        icon="MailIcon"
                                        size="15"
                                    /> {{ candidate._source.email }}
                            </a></u></b></span>
                            <span class="px-2 text-primary" v-if="!candidate.showContact"  @click="getContactNumber(candidate)"> <b><u><feather-icon
                                                icon="EyeIcon"
                                                size="15"
                                            /> View Contact Number</u></b>
                            </span>
                            <span class="px-2 text-primary" v-else> <feather-icon
                                                icon="PhoneIcon"
                                                size="15"
                                            /> {{ candidate._source.contact_no }}
                            </span>
                            
                        </small>
                        
                    </div>                                    
                    
                    <b-card-body style="margin-top: 0;margin-bottom: 0;padding-top: 0;padding-bottom: 0">
                    <!-- Candidate Details Section -->
                    <b-row style="margin-top: 0px;margin-bottom: 0;padding-top: 0;padding-bottom: 0">
                        <!-- Left Section (60%) -->
                        <b-col md="6" lg="6" style="margin-top: 0;margin-bottom: 0;padding-top: 0;padding-bottom: 0; padding-left: 10px">
                            
                            <div class="mb-0 pt-1 px-2">
                                <small>Current Company:  &nbsp;&nbsp;&nbsp;&nbsp;<strong>{{ candidate._source.curr_company }}</strong> </small>
                            </div>
                            <div class="mb-0  px-2">
                                <small>Current Role: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>{{ candidate._source.curr_position }}</strong> </small>
                            </div>
                            <div class="mb-0  px-2">
                                <small>Skills:  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>{{ candidate._source.skills }}</strong> </small>
                            </div>
                            <div class="mb-0  px-2">
                                <small>Added on:  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>{{ candidate._source.createdAt }} ({{ candidate._source.candidateStatus }})</strong> </small>
                                <small v-if="candidate._source.viewed">Last Accessed:  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>{{ JSON.stringify(candidate._source.viewed) }} </strong> </small>
                            </div> 
                        </b-col>
                        
                        <!-- Right Section (40%) -->
                        <b-col md="6" lg="6" style="margin-top: 0;margin-bottom: 0;padding-top: 0;padding-bottom: 0; padding-left: 10px">
                            
                            <div class="mb-0 pt-1 px-2">
                                <small>Preferred Location: &nbsp;&nbsp;&nbsp;&nbsp;<strong>{{ candidate._source.pref_location }}</strong> </small>
                            </div>
                            <div class="mb-0  px-2">
                                <small>Qualification: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>{{ candidate._source.qualification }}</strong> </small>
                            </div>
                            <div class="mb-0  px-2">
                                <small>Source:  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>{{ candidate._source.source }}</strong> </small>
                            </div>
                            <div class="mb-0  px-2">
                                <small>Gender:  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>{{ candidate._source.gender }}</strong> </small>
                            </div>
                        </b-col>
                        <b-col md="12" lg="12">
                            <div class="mb-0 mt-1  px-2 text-primary">
                                <small>Skills Matched: <strong v-if="candidate.highlight">{{ extractHighlightedWords(candidate.highlight) }}</strong> </small>
                            </div>
                        </b-col>
                        <b-col md="12" lg="12">
                            <div class="mb-0 mt-1  px-2 text-primary">{{ candidate._source.job_ids }}</div>
                        </b-col>
                    </b-row>
                    </b-card-body>
                    <!-- Checkbox for Candidate Selection -->
                    
                </b-card>

                <!-- Pagination -->
                <div class="row text-center" style="justify-content: center;" v-if="candidates.length > 0">
                    <b-pagination
                    v-model="filter.currentPage"
                    :total-rows="this.totalCount"
                    :per-page="filter.perPage"
                    aria-controls="candidate-list"
                    @change="changePage"
                ></b-pagination>
                </div>
                

            </b-col>
            <b-col md="4" lg="4" sm="4" v-if="$can('read','search')">
                <b-tabs>
                    <b-tab>
                        <template #title>
                            <feather-icon icon="EyeIcon" />
                            <span>Similar</span>
                        </template>
                        <b-list-group v-if="similarSearches.length > 0">
                            
                            <b-list-group-item class="flex-column align-items-start" v-for="(search, index) in similarSearches" :key="index">
                                <div class="mb-1 " style="text-overflow:ellipsis; overflow:hidden ;white-space: initial">
                                    
                                    <span v-html="computeSearchQuery(search.search_query)"></span>
                                </div>
                                <small class="text-info" @click="fillSearch(search.search_query)"> <Span>Fill this Search</Span></small>
                                <hr>
                            </b-list-group-item>

                            
                        </b-list-group>
                        <span v-else> No Similar Searches</span>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            <feather-icon icon="ClockIcon" />
                            <span>Recent</span>
                        </template>
                        <b-list-group flush v-if="recentSearches.length > 0">
                            <b-list-group-item class="flex-column align-items-start" v-for="(search, index) in recentSearches" :key="index">
                                <div class="mb-1 " style="text-overflow:ellipsis; overflow:hidden ;white-space: initial">
                                    
                                    <span v-html="computeSearchQuery(search.search_query)"></span>
                                </div>
                                <small class="text-primary" @click="fillSearch(search.search_query)"> <Span><u>Fill this Search</u></Span></small>
                                <hr>
                            </b-list-group-item>
                        </b-list-group>
                        <span v-else> No Recent Searches</span>
                    </b-tab>  
                    
                    <b-tab>
                        <template #title>
                            <feather-icon icon="BookmarkIcon" />
                            <span>Saved</span>
                        </template>
                        <b-list-group v-if="savedSearches.length > 0">
                            <b-list-group-item class="flex-column align-items-start" v-for="(search, index) in savedSearches" :key="index">
                                <div class="mb-1 " style="text-overflow:ellipsis; overflow:hidden ;white-space: initial">
                                    <span class="text-primary"><b><u>{{ search.title }}</u></b></span><br>
                                    <span v-html="computeSearchQuery(search.search_query)"></span>
                                </div>
                                <small class="text-info " @click="fillSearch(search.search_query)"> <Span class="border-right mx-2 px-2">Fill this Search</Span> <Span @click="shareSearch(search)">Share</Span></small>
                                <hr>
                            </b-list-group-item>

                            
                        </b-list-group>
                        <span v-else> No Saved Searches</span>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            <feather-icon icon="Share2Icon" />
                            <span>Shared</span>
                        </template>
                        <b-list-group v-if="sharedSearches.length > 0">
                            <b-list-group-item class="flex-column align-items-start" v-for="(search, index) in sharedSearches" :key="index">
                                <div class="mb-1 " style="text-overflow:ellipsis; overflow:hidden ;white-space: initial">
                                    <span class="text-primary"><b><u>{{ search.title }}</u></b></span><br>
                                    <span v-html="computeSearchQuery(search.search_query)"></span>
                                </div>
                                <small class="text-info " @click="fillSearch(search.search_query)"> <Span class="border-right mx-2 px-2">Fill this Search</Span> <Span @click="shareSearch(search)">Share</Span></small>
                                <hr>
                            </b-list-group-item>

                            
                        </b-list-group>
                        <span v-else> No Saved Searches</span>
                    </b-tab>
                </b-tabs>      
                <!-- <h5 class="text-primary">  <feather-icon
                      icon="ClockIcon"
                      size="18"
                      class=" align-middle mr-25 "
                    />Recent Searches</h5>
                    <strong><hr></strong> -->
                

                <!-- <h5 class="mt-2 text-primary">  <feather-icon
                      icon="BookmarkIcon"
                      size="18"
                      class="text-primary align-middle mr-25"
                    />Saved Searches</h5> -->
                <!-- <b-list-group v-if="savedSearches.length < 0">
                    <b-list-group-item class="flex-column align-items-start" v-for="(search, index) in savedSearches" :key="index">
                        <div class="d-flex w-100 justify-content-between">
                            <h5 class="mb-1">
                            Position Name
                            </h5>
                            
                        </div>
                        <b-card-text class="mb-1">
                            Search Input
                        </b-card-text>
                        <small class="text-info" @click="fillSearch(search.search_query)"> <Span>Fill this Search</Span></small>
                    </b-list-group-item>

                    
                </b-list-group>
                <span v-else> No Saved Searches</span> -->
                <!-- <b-card>
                <div style="text-align: center"> <b-button variant="outline-success" @click="filterCandidates()">Apply Filters</b-button></div>
                <div class="text-success">
                    <div class="mt-2">
                        <strong>Experience in years</strong>
                        <b-row>
                            <b-col md="6" xl="6" xs="6" class="mb-1">
                            <b-form-group
                                label="Min"
                                label-for="min-exp">
                                <v-select
                                    v-model="minExp"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="min-exp"
                                    placeholder="min exp"
                                    :options="experiences"
                                />
                            </b-form-group>
                            </b-col>
                            <b-col md="6" xl="6" xs="6" class="mb-1">
                            <b-form-group
                                label="Max"
                                label-for="max-exp">
                                <v-select
                                    v-model="maxExp"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="max-exp"
                                    placeholder="max exp"
                                    :options="experiences"
                                />
                                <small v-if="maxExp < minExp" class="text-danger">Max Exp cannot be less than Min Exp</small>
                            </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <div class="mt-0">
                        <strong>CTC in Lakhs</strong>
                        <b-row>
                            <b-col md="6" xl="6" xs="6" class="mb-1">
                            <b-form-group
                                label="Min"
                                label-for="min-exp">
                                <v-select
                                    v-model="minCTC"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="min-ctc"
                                    placeholder="min ctc"
                                    :options="ctcOptions"
                                />
                            </b-form-group>
                            </b-col>
                            <b-col md="6" xl="6" xs="6" class="mb-1">
                                <b-form-group
                                label="Max"
                                label-for="max-exp">
                                <v-select
                                    v-model="maxCTC"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="max-ctc"
                                    placeholder="max ctc"
                                    :options="ctcOptions"
                                />
                                <small v-if="maxCTC < minCTC" class="text-danger">Max CTC cannot be less than Min CTC</small>
                            </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <div class="mt-0">
                        <strong>Notice Period</strong>
                        <b-row>
                            <b-col md="12">
                                <b-form-group>
                                <b-form-radio-group
                                    v-model="noticePeriod"
                                    :options="noticePeriodOptions"
                                    name="radios-stacked"
                                    class="demo-inline-spacing"
                                />
                            </b-form-group>
                        </b-col>
                        </b-row>
                    </div>
                    <div class="mt-0">
                        <strong>Location</strong>
                        <b-row>
                            <b-col md="12">
                                <b-form-group>
                                <v-select
                                    v-model="locations"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="title"
                                    :options="citiesOptions"
                                    placeholder="Select Locations"
                                    multiple
                                    :close-on-select="false"
                                />
                            </b-form-group>
                        </b-col>
                        </b-row>
                    </div>
                    <div class="mt-0">
                        <strong>Qualification</strong>
                        <b-row>
                            <b-col md="12">
                                <b-form-group>
                                <v-select
                                    v-model="qualifications"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="title"
                                    placeholder="Select Qualifications"
                                    :options="qualificationOptions"
                                    multiple
                                    :close-on-select="false"
                                />
                            </b-form-group>
                        </b-col>
                        </b-row>
                    </div>
                    <div class="mt-0">
                        <strong>Gender</strong>
                        <b-row>
                            <b-col md="12">
                                <b-form-group>
                                <v-select
                                    v-model="genders"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                    label="title"
                                    placeholder="Select Gender"
                                    :options="genderOptions"
                                    multiple
                                    :close-on-select="false"
                                />
                            </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <div class="mt-0">
                        <strong>Company </strong>
                        <b-row>
                            <b-col md="12">
                                <b-form-group>
                                <b-form-input
                                    v-model="company"
                                    placeholder="Companies perferred"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                />
                            </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <div class="mt-0">
                        <strong>Role </strong>
                        <b-row>
                            <b-col md="12">
                                <b-form-group>
                                <b-form-input
                                    v-model="role"
                                    placeholder="Role perferred"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                />
                            </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <div class="mt-0">
                        <strong>Exclude Company </strong>
                        <b-row>
                            <b-col md="12">
                                <b-form-group>
                                <b-form-input
                                    v-model="excludeCompany"
                                    placeholder="companies not perferred"
                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                />
                            </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <div class="mt-0">
                        <strong>Exclude Recently Joined</strong>
                        <b-row>
                            <b-col md="12">
                                <b-form-group>
                                    <b-form-radio-group
                                    v-model="excludeJoined"
                                    :options="joinedOptions"
                                    name="radios-stacked"
                                    class="demo-inline-spacing"
                                />
                            </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                </div>
                <div style="text-align: center"> <b-button variant="outline-success" @click="filterCandidates()">Apply Filters</b-button></div>
                </b-card>     -->
            </b-col>
        </b-row>
        
    <template>
        <b-modal
            id="modal-mass-mailer"
            ref="modal-mass-mailer"
            title="Mass Mailer Template"
            ok-title="submit"
            @ok="sendMassMail()"
            cancel-variant="outline-secondary"
            size="lg"
        >
        <h6 class="text-primary">Search Position For Which you want to send Mass Mail</h6>
        <b-form>
            <b-form-group
            label="Search Active Position by Job Id"
            label-for="search-position"
            >
            <b-input-group>
                <b-form-input placeholder="SHJ-1000" v-model="filter.jobId" />
                    <b-input-group-append>
                        <b-button variant="outline-primary" @click="getJob()">
                        SEARCH
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
            <div v-if="job" class="mb-1">
                <h5 class="text-primary">Job Details</h5>
                <b-row >
                    <b-col sm="6" md="6"><div><span class="text-primary">Position Name: </span> {{ job.position_name }}</div></b-col>
                    <b-col sm="6" md="6"><div><span class="text-primary">Client: </span> {{ JSON.parse(job.client)[0].title }} ({{ job.poc }})</div></b-col>
                    <b-col sm="6" md="6"><div><span class="text-primary">Location: </span> {{ job.locations }}</div></b-col>
                    <b-col sm="6" md="6"><div><span class="text-primary">Exp: </span> {{ job.min_exp }} - {{ job.max_exp }} years</div></b-col>
                    <b-col sm="6" md="6"><div><span class="text-primary">CTC: </span> {{ job.min_ctc }} - {{ job.max_ctc }} lakhs</div></b-col>
                    <b-col sm="6" md="6"><div><span class="text-primary">Notice Period: </span> {{ job.notice_period }} </div></b-col>
                    
                </b-row>
            </div>
            <div v-if="jobNotFoundError && !job" class="text-danger mb-1"> {{ jobNotFoundError }}</div>

            <h5 class="mb-2 mt-2 text-center text-primary"><u>Mass Mailer Template </u></h5>
            <div v-html="massMailerTemplate"></div>
            <!-- <b-form-group
            label="Customise Mail Template"
            label-for="mail-quill-editor"
            >
            <quill-editor
                v-model="massMailerTemplate"
                :options="snowOption"
                read-only="readOnly"
            />
            </b-form-group> -->
            
        </b-form>
        </b-modal>
    </template> 
    <template>
        <b-modal
            id="modal-assign-to-job"
            title="Assign To Job"
            ok-title="Assign To Job"
            @ok="assignJob"
            cancel-variant="outline-secondary"
            size="lg"
            
        >
        <h6 class="text-primary">Search Position For Which you want to Assign Job</h6>
        <b-form>
            <b-form-group
            label="Search Active Position by Job Id"
            label-for="search-position"
            >
            <b-input-group>
                <b-form-input placeholder="SHJ-1000" v-model="filter.jobId" />
                    <b-input-group-append>
                        <b-button variant="outline-primary" @click="getJob()">
                        Search
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
            <div v-if="job" class="mb-1">
                <h5 class="text-primary">Job Details</h5>
                <b-row >
                    <b-col sm="6" md="6"><div><span class="text-primary">Position Name: </span> {{ job.position_name }}</div></b-col>
                    <b-col sm="6" md="6"><div><span class="text-primary">Client: </span> {{ JSON.parse(job.client)[0].title }} ({{ job.poc }})</div></b-col>
                    <b-col sm="6" md="6"><div><span class="text-primary">Location: </span> {{ job.locations }}</div></b-col>
                    <b-col sm="6" md="6"><div><span class="text-primary">Exp: </span> {{ job.min_exp }} - {{ job.max_exp }} years</div></b-col>
                    <b-col sm="6" md="6"><div><span class="text-primary">CTC: </span> {{ job.min_ctc }} - {{ job.max_ctc }} lakhs</div></b-col>
                    <b-col sm="6" md="6"><div><span class="text-primary">Notice Period: </span> {{ job.notice_period }} </div></b-col>
                    
                </b-row>
            </div>
            <!-- <span class="text-primary"> Total {{ selected.length }} Candidates Selected!!!</span> -->
            
            <div v-if="jobNotFoundError" class="text-danger mb-1"> {{ jobNotFoundError }}</div>
            
        </b-form>
        </b-modal>
    </template>
    <template>
        <b-modal
            id="cv-preview-modal"
            ref="cv-preview-modal"
            ok-only
            ok-title="Accept"
            centered
            size="xl"
            title="CV Preview"
        >
            <a class="text-center font-weight-bolder" :href="mlink" target="_blank" v-if="docx || doc"> Preview CV</a>
            <div>
                <div v-if="pdf">
                    <iframe :src="blink" frameborder="0" height="1200px" width="100%"></iframe>
                </div>
                <div v-if="docx || doc">
                    <iframe :src="mlink" frameborder="0" height="1200px" width="100%"></iframe>
                </div>
                <div v-if="rtf">
                    <iframe :src="glink" frameborder="0" height="1200px" width="100%"></iframe>
                </div>
                <div v-if="otherDoc">
                    <iframe :src="mlink" frameborder="0" height="1200px" width="100%"></iframe>
                </div>
            </div>
        </b-modal>
    </template>
    <template>
        <b-modal
            id="modal-save-search"
            title="Save Search"
            ok-title="Save"
            @ok="saveSearch"
            cancel-variant="outline-secondary"
            size="md"
            
        >
        
        <b-form>
            <b-form-group
            label="Search Title"
            label-for="search-title"
            >
                <b-input-group>
                    <b-form-input placeholder="search title" v-model="searchTitle" />
                </b-input-group>
            </b-form-group>
        </b-form>
        </b-modal>
    </template>
    <template>
        <b-modal
        id="modal-ni-nr-reason"
        ref="modal-ni-nr-reason"
        no-close-on-backdrop
        :title="NI === true ? 'Select Reason & Add Comment for Not Interested Candidate': 'Add Comment for Not Relevant Candidate'"
        ok-title="submit"
        cancel-variant="outline-secondary"
        @ok="updateCandidateNINRReason"
      >
        <b-form>
          <b-form-group label="Choose the Reason *" label-for="vue-select"  v-if="NI">
            
            <v-select
                      v-model="NI_Reason_Selected"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="NotInterestedReason"
                      ref="ni-reaon"
                    />
          </b-form-group>
          <b-form-group label="Add Comment *" label-for="vue-select">
                <b-form-textarea
                  id="textarea-default"
                  v-model="NI_NR_comment"
                  placeholder="add comment for not interested, not relevant candidate"
                  rows="3"
                />
                <small v-if="!NI_NR_comment" class="text-danger"> {{ error_NI_NR_comment }}</small>
              </b-form-group>
        </b-form>
      </b-modal>
    </template>
    <template>
        <b-modal
        id="modal-na-status"
        ref="modal-na-status"
        no-close-on-backdrop
        title="Select Proper Status for Candidate"
        ok-title="submit"
        cancel-variant="outline-secondary"
        @ok="updateNotAnswered(candidate_id)"
      >
        <b-form>
          <b-form-group label="Choose the Reason *" label-for="vue-select"  v-if="NI">
            
            <v-select
                      v-model="NA_Reason_Selected"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="NotAnsweredOptions"
                      ref="na-reason"
                    />
          </b-form-group>
          <b-form-group label="Add Comment" label-for="vue-select">
                <b-form-textarea
                  id="textarea-default"
                  v-model="NA_comment"
                  placeholder="add comment for Call Back Candidates"
                  rows="3"
                />
                <small v-if="!NA_comment" class="text-danger"> {{ error_NA_comment }}</small>
              </b-form-group>
        </b-form>
      </b-modal>
    </template>
      
    </section>
</template>
<script>
import {
    BCard,
    BButton,
    BRow,
    BCol,
    VBTooltip,
    BCardBody,
    BCardText,
    BDropdown,
    BFormRadio,
    BFormRadioGroup,
    BDropdownItem,
    BInputGroup,
    BInputGroupAppend,
    BForm,
    BFormGroup,
    BFormTextarea,
    BCardHeader,
    BSidebar,
    BBadge,
    BFormInput,
    BPagination,
    BMedia,
    BLink,
    BFormCheckbox,
    BListGroup,
    BListGroupItem, BModal, VBModal, BSpinner, BTabs, BTab,//BButton, BSidebar, VBToggle
    BButtonGroup
  } from "bootstrap-vue";
  import Ripple from "vue-ripple-directive";
  import vSelect from 'vue-select'
import { isBoolean } from '@vueuse/core';
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import jobService from '@/services/job-service';
import CandidateService from "@/services/candidate-service";
import jobTimelineService from "@/services/job-timeline";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
//import JobService from '@/services/job-service'
// import CandidateService from '@/services/candidate-service'
// import jobTimelineService from '@/services/job-timeline'
import searchesService from "@/services/searches-service";
import mailService from "@/services/mail-service"
import elasticSearchService from "@/services/elastic-search-service"
import adminConfigService from "@/services/admin-config-service";
import { saveAs } from 'file-saver'
import * as XLSX from 'xlsx'



export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    VBTooltip,
    BCardBody,
    BCardText,
    BDropdown,
    BDropdownItem,
    BFormRadio,
    BFormRadioGroup,
    BForm,
    BFormGroup,
    BFormTextarea,
    BCardHeader,
    BSidebar,
    BBadge,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BPagination,
    BMedia,
    BLink,
    BFormCheckbox,
    vSelect,
    BListGroup,
    BListGroupItem,
    BModal, VBModal,
    quillEditor,
    BSpinner,
    BTabs, BTab, BButtonGroup
  },
  directives: {
    "b-tooltip": VBTooltip,
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return{
        booleanSearchString: null,
        isValidBoolean: false,        
        experiences: ["0",0.5, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50],        
        excludeJoined: null,
        //skillOptions: [],
         // Initial page number
        isBoolean: false,
        joinedOptions: [
        { text: 'All', value: 0 },
        { text: 'Less than 30 Days', value: 30 },
        { text: 'Less than 60 Days', value: 60 },
        { text: 'Less than 90 Days', value: 90 },],
        noticePeriodOptions: [
        { text: '0', value: 0 },
        { text: '0-15 Days', value: 15 },
        { text: '0-30 Days', value: 30 },
        { text: '0-45 Days', value: 45 },
        { text: '0-60 Days', value: 60 },
        { text: '0-90 Days', value: 90 },],
        
        filter: {
            minCTC: 0,
            maxCTC: null,
            minExp: 0,
            maxExp: null,
            excludeCompany: null,
            locations: null,
            genders: null,
            qualifications: null,
            noticePeriod: null,
            company: null,
            role: null,
            selected: null,
            //isBoolean: false,
            booleanSearchString: null,
            jobId: null,
            source: null,
            perPage: parseInt(this.$route.query.perPage) || 25,
            currentPage: parseInt(this.$route.query.currentPage) || 1,
        },
        ctcOptions: ["0", 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 120, 140, 160, 180, 200, 220, 240, 260, 280, 300],
        citiesOptions: [{"title":"Mumbai"},{"title":"Delhi"},{"title":"Bangalore"},{"title":"Hyderabad"},{"title":"Pune"},{"title":"Ahmedabad"},{"title":"Chennai"},{"title":"Kolkata"},{"title":"Surat"},{"title":"Jaipur"},{"title":"Lucknow"},{"title":"Kanpur"},{"title":"Nagpur"},{"title":"Indore"},{"title":"Thane"},{"title":"Bhopal"},{"title":"Visakhapatnam"},{"title":"Pimpri and Chinchwad"},{"title":"Patna"},{"title":"Vadodara"},{"title":"Ghaziabad"},{"title":"Ludhiana"},{"title":"Agra"},{"title":"Nashik"},{"title":"Faridabad"},{"title":"Meerut"},{"title":"Rajkot"},{"title":"Kalyan and Dombivali"},{"title":"Vasai Virar"},{"title":"Varanasi"},{"title":"Srinagar"},{"title":"Aurangabad"},{"title":"Dhanbad"},{"title":"Amritsar"},{"title":"Navi Mumbai"},{"title":"Allahabad"},{"title":"Haora"},{"title":"Ranchi"},{"title":"Gwalior"},{"title":"Jabalpur"},{"title":"Coimbatore"},{"title":"Vijayawada"},{"title":"Jodhpur"},{"title":"Madurai"},{"title":"Raipur"},{"title":"Kota"},{"title":"Chandigarh"},{"title":"Guwahati"},{"title":"Solapur"},{"title":"Hubli and Dharwad"},{"title":"Bareilly"},{"title":"Mysore"},{"title":"Moradabad"},{"title":"Gurgaon"},{"title":"Aligarh"},{"title":"Jalandhar"},{"title":"Tiruchirappalli"},{"title":"Bhubaneswar"},{"title":"Salem"},{"title":"Mira and Bhayander"},{"title":"Thiruvananthapuram"},{"title":"Bhiwandi"},{"title":"Saharanpur"},{"title":"Gorakhpur"},{"title":"Guntur"},{"title":"Amravati"},{"title":"Bikaner"},{"title":"Noida"},{"title":"Jamshedpur"},{"title":"Bhilai Nagar"},{"title":"Warangal"},{"title":"Cuttack"},{"title":"Firozabad"},{"title":"Kochi"},{"title":"Bhavnagar"},{"title":"Dehradun"},{"title":"Durgapur"},{"title":"Asansol"},{"title":"Nanded Waghala"},{"title":"Kolapur"},{"title":"Ajmer"},{"title":"Gulbarga"},{"title":"Loni"},{"title":"Ujjain"},{"title":"Siliguri"},{"title":"Ulhasnagar"},{"title":"Jhansi"},{"title":"Sangli Miraj Kupwad"},{"title":"Jammu"},{"title":"Nellore"},{"title":"Mangalore"},{"title":"Belgaum"},{"title":"Jamnagar"},{"title":"Tirunelveli"},{"title":"Malegaon"},{"title":"Gaya"},{"title":"Ambattur"},{"title":"Jalgaon"},{"title":"Udaipur"},{"title":"Maheshtala"},{"title":"Tiruppur"},{"title":"Davanagere"},{"title":"Kozhikode"},{"title":"Kurnool"},{"title":"Akola"},{"title":"Rajpur Sonarpur"},{"title":"Bokaro Steel"},{"title":"Bellary"},{"title":"Patiala"},{"title":"South Dum Dum"},{"title":"Rajarhat Gopalpur"},{"title":"Bhagalpur"},{"title":"Agartala"},{"title":"Muzaffarnagar"},{"title":"Bhatpara"},{"title":"Latur"},{"title":"Panihati"},{"title":"Dhule"},{"title":"Rohtak"},{"title":"Korba"},{"title":"Bhilwara"},{"title":"Brahmapur Town"},{"title":"Muzaffarpur"},{"title":"Ahmadnagar"},{"title":"Mathura"},{"title":"Kollam"},{"title":"Avadi"},{"title":"Kadapa"},{"title":"Rajahmundry"},{"title":"Bilaspur"},{"title":"Kamarhati"},{"title":"Shahjahanpur"},{"title":"Bijapur"},{"title":"Rampur"},{"title":"Shimoga"},{"title":"Chandrapur"},{"title":"Junagadh"},{"title":"Thrissur"},{"title":"Alwar"},{"title":"Barddhaman"},{"title":"Kulti"},{"title":"Kakinada"},{"title":"Nizamabad"},{"title":"Parbhani"},{"title":"Tumkur"},{"title":"Hisar"},{"title":"Ozhukarai"},{"title":"Biharsharif"},{"title":"Darbhanga"},{"title":"Panipat"},{"title":"Aizawl"},{"title":"Bally"},{"title":"Dewas"},{"title":"Tirupati"},{"title":"Ichalkaranji"},{"title":"Karnal"},{"title":"Bathinda"},{"title":"Jalna"},{"title":"Kirari Suleman Nagar"},{"title":"Purnia"},{"title":"Satna"},{"title":"Maunath Bhanjan"},{"title":"Barasat"},{"title":"Sonipat"},{"title":"Farrukhabad and Fatehgarh"},{"title":"Sagar"},{"title":"Raurkela"},{"title":"Durg"},{"title":"Imphal"},{"title":"Ratlam"},{"title":"Hapur"},{"title":"Arrah"},{"title":"Karimnagar"},{"title":"Anantapur"},{"title":"NDMC"},{"title":"Etawah"},{"title":"Ambernath"},{"title":"Bharatpur"},{"title":"Begusarai"},{"title":"Tiruvottiyur"},{"title":"North Dum Dum"},{"title":"Gandhidham"},{"title":"Baranagar"},{"title":"Puducherry"},{"title":"Thoothukkudi"},{"title":"Sikar"},{"title":"Rewa"},{"title":"Mirzapur and Vindhyachal"},{"title":"Raichur"},{"title":"Pali"},{"title":"Ramagundam"},{"title":"Hardwar"},{"title":"Vizianagaram"},{"title":"Katihar"},{"title":"Nagercoil"},{"title":"Ganganagar"},{"title":"Karawal Nagar"},{"title":"Mango"},{"title":"Thanjavur"},{"title":"Bulandshahr"},{"title":"Uluberia"},{"title":"Murwara"},{"title":"Sambhal"},{"title":"Singrauli"},{"title":"Nadiad"},{"title":"Secunderabad"},{"title":"Naihati"},{"title":"Yamunanagar"},{"title":"Bidhan Nagar"},{"title":"Pallavaram"},{"title":"Bidar"},{"title":"Munger"},{"title":"Panchkula"},{"title":"Burhanpur"},{"title":"Raurkela Industrial Township"},{"title":"Kharagpur"},{"title":"Dindigul"},{"title":"Hospet"},{"title":"Gandhinagar"},{"title":"Nangloi Jat"},{"title":"English Bazar"},{"title":"Ongole"},{"title":"Eluru"},{"title":"Deoghar"},{"title":"Chapra"},{"title":"Haldia"},{"title":"Khandwa"},{"title":"Puri Town"},{"title":"Nandyal"},{"title":"Morena"},{"title":"Amroha"},{"title":"Anand"},{"title":"Bhind"},{"title":"Bhalswa Jahangir Pur"},{"title":"Madhyamgram"},{"title":"Bhiwani"},{"title":"Navi Mumbai Panvel Raigad"},{"title":"Baharampur"},{"title":"Ambala"},{"title":"Morvi"},{"title":"Fatehpur"},{"title":"Rae Bareli"},{"title":"Khora"},{"title":"Bhusawal"},{"title":"Orai"},{"title":"Bahraich"},{"title":"Vellore"},{"title":"Mahesana"},{"title":"Khammam"},{"title":"Sambalpur"},{"title":"Raiganj"},{"title":"Sirsa"},{"title":"Dinapur Nizamat"},{"title":"Serampore"},{"title":"Sultan Pur Majra"},{"title":"Guna"},{"title":"Jaunpur"},{"title":"Panvel"},{"title":"Shivpuri"},{"title":"Surendranagar Dudhrej"},{"title":"Unnao"},{"title":"Hugli and Chinsurah"},{"title":"Sitapur"},{"title":"Hastsal"},{"title":"Tambaram"},{"title":"Adityapur"},{"title":"Badalapur"},{"title":"Alappuzha"},{"title":"Cuddalore"},{"title":"Silchar"},{"title":"Gadag and Betigeri"},{"title":"Bahadurgarh"},{"title":"Machilipatnam"},{"title":"Shimla"},{"title":"Medinipur"},{"title":"Deoli"},{"title":"Bharuch"},{"title":"Hoshiarpur"},{"title":"Jind"},{"title":"Chandannagar"},{"title":"Adoni"},{"title":"Tonk"},{"title":"Faizabad"},{"title":"Tenali"},{"title":"Alandur"},{"title":"Kancheepuram"},{"title":"Vapi"},{"title":"Rajnandgaon"},{"title":"Proddatur"},{"title":"Navsari"},{"title":"Budaun"},{"title":"Uttarpara Kotrung"},{"title":"Mahbubnagar"},{"title":"Erode"},{"title":"Batala"},
            {"title":"Saharsa"},{"title":"Haldwani and Kathgodam"},{"title":"Vidisha"},{"title":"Thanesar"},{"title":"Kishangarh"},{"title":"Dallo Pura"},{"title":"Veraval"},{"title":"Banda"},{"title":"Chittoor"},{"title":"Krishnanagar"},{"title":"Barrackpur"},{"title":"Lakhimpur"},{"title":"Santipur"},{"title":"Porbandar"},{"title":"Hindupur"},{"title":"Balurghat"},{"title":"Bhadravati"},{"title":"Hanumangarh"},{"title":"Moga"},{"title":"Pathankot"},{"title":"Hajipur"},{"title":"Sasaram"},{"title":"Habra"},{"title":"Bid"},{"title":"Mohali"},{"title":"Burari"},{"title":"Beawar"},{"title":"Abohar"},{"title":"Tiruvannamalai"},{"title":"Jamuria"},{"title":"Kaithal"},{"title":"Godhra"},{"title":"Bhuj"},{"title":"Robertson Pet"},{"title":"Shillong"},{"title":"Rewari"},{"title":"Hazaribag"},{"title":"Bhimavaram"},{"title":"Mandsaur"},{"title":"Chas"},{"title":"Rudrapur"},{"title":"Chitradurga"},{"title":"Kumbakonam"},{"title":"Dibrugarh"},{"title":"Kolar"},{"title":"Chhindwara"},{"title":"Bankura"},{"title":"Mandya"},{"title":"Dehri"},{"title":"Raigarh"},{"title":"Madanapalle"},{"title":"Nalgonda"},{"title":"Hathras"},{"title":"Malerkotla"},{"title":"Siwan"},{"title":"Chhattarpur"},{"title":"Hassan"},{"title":"Lalitpur"},{"title":"Gondiya"},{"title":"North Barrackpur"},{"title":"Bettiah"},{"title":"Palakkad"},{"title":"Rajapalayam"},{"title":"Botad"},{"title":"Modinagar"},{"title":"Deoria"},{"title":"Raniganj"},{"title":"Palwal"},{"title":"Khanna"},{"title":"Neemuch"},{"title":"Pilibhit"},{"title":"Mustafabad"},{"title":"Hardoi"},{"title":"Guntakal"},{"title":"Pithampur"},{"title":"Motihari"},{"title":"Dhaulpur"},{"title":"Srikakulam"},{"title":"Nabadwip"},{"title":"Patan"},{"title":"Jagdalpur"},{"title":"Udupi"},{"title":"Basirhat"},{"title":"Damoh"},{"title":"Halisahar"},{"title":"Jagadhri"},{"title":"Rishra"},{"title":"Kurichi"},{"title":"Dimapur"},{"title":"Palanpur"},{"title":"Dharmavaram"},{"title":"Gokal Pur"},{"title":"Kashipur"},{"title":"Ashokenagar Kalyangarh"},{"title":"Baidyabati"},{"title":"Sawai Madhopur"},{"title":"Puruliya"},{"title":"Mandoli"},{"title":"Mainpuri"},{"title":"Kanchrapara"},{"title":"Satara"},{"title":"Churu"},{"title":"Madavaram"},{"title":"Gangapur"},{"title":"Dabgram"},{"title":"Darjiling"},{"title":"Barshi"},{"title":"Etah"},{"title":"Jhunjhunun"},{"title":"Chikmagalur"},{"title":"Jetpur Navagadh"},{"title":"Roorkee"},{"title":"Gudivada"},{"title":"Baleshwar"},{"title":"Baran"},{"title":"Hoshangabad"},{"title":"Nagaon"},{"title":"Pudukkottai"},{"title":"Adilabad"},{"title":"Hosur"},{"title":"Muktsar"},{"title":"Yavatmal"},{"title":"Titagarh"},{"title":"Barnala"},{"title":"Chittaurgarh"},{"title":"Narasaraopet"},{"title":"Dum Dum"},{"title":"Basti"},{"title":"Valsad"},{"title":"Ambur"},{"title":"Giridih"},{"title":"Chandausi"},{"title":"Gonda"},{"title":"Bally Town"},{"title":"Kalol"},{"title":"Bagaha"},{"title":"Ambikapur"},{"title":"Achalpur"},{"title":"Gondal"},{"title":"Bagalkot"},{"title":"Osmanabad"},{"title":"Akbarpur"},{"title":"Champdani"},{"title":"Deesa"},{"title":"Khurja"},{"title":"Nandurbar"},{"title":"Azamgarh"},{"title":"Ghazipur"},{"title":"Delhi Cantonment"},{"title":"Firozpur"},{"title":"Baripada"},{"title":"Mughalsarai"},{"title":"Anantnag"},{"title":"Sehore"},{"title":"Bongaon"},{"title":"Kanpur Cantonment"},{"title":"Khardaha"},{"title":"Tadpatri"},{"title":"Port Blair"},{"title":"Sultanpur"},{"title":"Bhadrak"},{"title":"Shikohabad"},{"title":"Jalpaiguri"},{"title":"Shamli"},{"title":"Karaikkudi"},{"title":"Khargone"},{"title":"Wardha"},{"title":"Ranibennur"},{"title":"Kishanganj"},{"title":"Neyveli"},{"title":"Amreli"},{"title":"Suryapet"},{"title":"Gangawati"},{"title":"Hindaun"},{"title":"Jamalpur"},{"title":"Bhiwadi"},{"title":"Ballia"},{"title":"Bansberia"},{"title":"Tadepalligudem"},{"title":"Miryalaguda"},{"title":"Baraut"},{"title":"Udgir"},{"title":"Betul"},{"title":"Bundi"},{"title":"Jehanabad"},{"title":"Ambala Sadar"},{"title":"Nagapattinam"},{"title":"Nagaur"},{"title":"Buxar"},{"title":"Seoni"},{"title":"Greater Noida"},{"title":"Hinganghat"},{"title":"Sujangarh"},{"title":"Bhadreswar"},{"title":"Chilakaluripet"},{"title":"Kasganj"},{"title":"Kalyani"},{"title":"Gangtok"},{"title":"Datia"},{"title":"Nagda"},{"title":"Banswara"},{"title":"Kapurthala"}, {"title": "Ratnagiri"}, {"title": "Goa"}, {"title": "Panaji"}],
        qualificationOptions: [],
                genderOptions: [
                    { title: "Male" },
                    { title: "Female" },
                    { title: "LGBQ" },
                    { title: "Transgender" },
                ],
                sourceOptions: [
                    { title: "Naukri" },
                    { title: "Monster" },
                    { title: "LinkedIn" },
                    { title: "Indeed" },
                    { title: "Shine" },
                    { title: "TimesJobs" },
                    { title: "IIMJobs" },
                    { title: "Glassdoor" },
                    { title: "FreshersWorld" },
                    { title: "Other" },
                    { title: "Train N Hire" },
                    { title: "Internal" },
                    { title: "Referenced" },
                    { title: "MassMailer" },
                ],
        statusOptions: [
            { value: "UploadedBySourcer", title: "UploadedBySourcer" },
            { value: "UploadedByRecruiter", title: "UploadedByRecruiter" },
            { value: "AssignedByMassMail", title: "AssignedByMassMail" },
            { value: "Wrong Number", title: "Wrong Number" },
            { value: "Not Answered", title: "Not Answered" },
            { value: "Not Reachable", title: "Not Reachable" },
            { value: "Not Interested", title: "Not Interested" },
            { value: "Not Relevant", title: "Not Relevant" },
            { value: "Call Back", title: "Call Back" },
            { value: "ProfileShared", title: "ProfileShared" },
            { value: "ReviewReject", title: "ReviewReject" },
            { value: "Initiated", title: "Initiated" },
            { value: "Screen Reject", title: "ScreenReject" },
            { value: "Screen Select", title: "ScreenSelect" },
            { value: "Duplicate", title: "Duplicate" },
            { value: "Inprocess", title: "Inprocess" },
            { value: "OnHold", title: "OnHold" },
            { value: "Shortlisted", title: "Shortlisted" },
            { value: "Offered", title: "Offered" },
            { value: "Not Offered", title: "NotOffered" },
            { value: "Joined", title: "Joined" },
            { value: "Offer Drop", title: "OfferDrop" },
            { value: "Rejected", title: "Rejected" },
        ],            
        candidates: [],
       selectedCandidates: [],
       filteredCandidates: [],
       //matchedCandidates: [],
       inputText: '',
       badges: [],
       recentSearches: [],
       savedSearches: [],
       sharedSearches: [],
       similarSearches: [],
       skillOptions:  [
        // { keyword: 'Financial Planning and Analysis', isMandatory: false, isExcluded: false },
        // { keyword: 'FPNA', isMandatory: false, isExcluded: false },
      ],
      //selected: null,
      positionId: null,
      massMailerTemplate: null,
      snowOption: {
        theme: 'snow',
      },
      jobNotFoundError: null,
      job: null,
      totalCount: 0,
      loading: false,
      error: null,
      searchQuery: {},
      blink: null,
      glink: null,
      pdf: false,
      docx: false,
      doc: false,
      rtf: false,
      otherDoc: false,
      mlink: null,
      dlink: null,
      user: null,
      jobSearchMatchPercent: 0,
      keywordsMatchCount: 0,
      searchTitle: null,
      NotInterestedReason: [
        { title: "Not Looking for Change"},
        { title: "Not ok with the Client/Company"},
        { title: "Not ok with Location"},
        { title: "Not ok with Shift"},
        { title: "Not ok with Compensation"},
        { title: "Not ok with Designation/Role"},
        { title: "Recently Changed"},
        { title: "Already Interviewed/Duplicate"},
        { title: "Already working with Organization"},
        { title: "Re-Hire"},
        { title: "Ex-Employee"},
        { title: "Other"},
      ],
      NotAnsweredOptions: [
        { title: 'Not Answered'},
        { title: 'Not Reachable'},
        { title: 'Wrong Number'},
        { title: 'Call Back'}
      ],
      NI_Reason_Selected: null,
      NI_NR_comment: null,
      error_NI_NR_comment: '',
      NI: true,
      NA_comment: null,
      NA_Reason_Selected: null,
      error_NA_comment: '',
      statusCSelected: null,
      candidate_id: null,
      isValid: false,
      userRole: null,
      agingSelected: null,
      selectedJobFilter: null,
      jobFilterSearch: '',
    }
  },
  computed: {
        // selectedClasses() {
        //     return this.skillOptions.map(skill => {
        //     if (skill.isMandatory === true) {
        //         return 'vs__selected--mandatory';
        //     } else if (skill.isExcluded === true) {
        //         return 'vs__selected--excluded';
        //     } else if (skill.isMandatory === false && skill.isExcluded === false) {
        //         return 'vs__selected--neutral';
        //     }
        //     });
        // }
        availableJobs() {
          if (!this.candidates.length) return [];

          // Get unique jobs from candidates and count occurrences
          const jobsMap = this.candidates.reduce((acc, candidate) => {
            const jobId = candidate._source.job_id;
            const jobTitle = candidate._source.job_title || 'Unknown Job';
            
            if (!acc[jobId]) {
              acc[jobId] = {
                id: jobId,
                title: jobTitle,
                count: 0
              };
            }
            acc[jobId].count++;
            return acc;
          }, {});

          return Object.values(jobsMap).sort((a, b) => b.count - a.count);
        },

        displayedCandidates() {
          return this.selectedJobFilter 
            ? this.filteredCandidates 
            : this.candidates;
        }
   },
   watch: {
    //   filter: {
    //     handler(newFilters) {
    //       // Convert query parameters and new filters to strings for easy comparison
    //       const currentQuery = JSON.stringify(this.$route.query);
    //       //console.log('current query filters', currentQuery.selected)
    //       const newQuery = JSON.stringify(newFilters);
    //     //   if(typeof newFilters.selected === 'object') {
    //     //     newFilters.selected = JSON.stringify(newFilters.selected)
    //     //   }

    //       // Only navigate if the queries are different
    //       if (currentQuery !== newQuery) {
    //         console.log('new filters', newFilters)
    //         // if(currentQuery.selected !== newFilters.selected) {
    //         //   newFilters.selected = JSON.stringify(newFilters.selected)  
    //         // }
    //         this.$router.push({ query: newFilters }).catch(err => {
    //           if (err.name !== 'NavigationDuplicated') {
    //             throw err;
    //           }
    //           // Ignore NavigationDuplicated error, but rethrow all other errors
    //         });
    //       }
    //     },
    //     deep: true,
    //   },
      
    //   $route(to) {
    //     this.filter = { ...this.filter, ...to.query };
    //   },
        filter: {
            handler(newFilters) {
            // Clone newFilters to avoid mutating the original object
            const filtersForQuery = { ...newFilters };

            // Serialize the 'selected' field if it's an array
            if (Array.isArray(filtersForQuery.selected)) {
                filtersForQuery.selected = JSON.stringify(filtersForQuery.selected);
            }

            const currentQuery = JSON.stringify(this.$route.query);
            const newQuery = JSON.stringify(filtersForQuery);

            if (currentQuery !== newQuery) {
                this.$router.push({ query: filtersForQuery }).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    throw err;
                }
                });
            }
            },
            deep: true,
        },
        $route(to) {
        // Clone to.query to avoid mutating the original object
            const queryFilters = { ...to.query };

            // Deserialize the 'selected' field if it exists and is a string
            if (queryFilters.selected && typeof queryFilters.selected === 'string') {
            try {
                queryFilters.selected = JSON.parse(queryFilters.selected);
            } catch (e) {
                // Handle the case where the string is not valid JSON
                console.error('Error parsing selected:', e);
            }
            }

            this.filter = { ...this.filter, ...queryFilters };
        },

    },
  created() {
    //this.matchedCandidates = this.candidates

    //console.log('route queries', this.filter)
    this.user = JSON.parse(localStorage.getItem('userData')).emp_id
    this.userRole = JSON.parse(localStorage.getItem('userData')).roles[0]

    
      
      if(this.$route.query) {
          //this.searchFilters = { ...this.searchFilters, ...this.$route.query };
          this.filter.selected = this.$route.query.selected ? JSON.parse(this.$route.query.selected) : ''
          this.filter.minExp = this.$route.query.minExp ? this.$route.query.minExp : ''
          this.filter.maxExp = this.$route.query.maxExp ? this.$route.query.maxExp : ''
          this.filter.minCTC = this.$route.query.minCTC ? this.$route.query.minCTC : ''
          this.filter.maxCTC = this.$route.query.maxCTC ? this.$route.query.maxCTC : ''
          this.filter.noticePeriod = this.$route.query.noticePeriod ? this.$route.query.noticePeriod : ''
          this.filter.locations = this.$route.query.locations ? this.$route.query.locations : ''
          this.filter.qualifications = this.$route.query.qualifications ? this.$route.query.qualifications : ''
          this.filter.genders = this.$route.query.genders ? this.$route.query.genders : ''
          this.filter.company = this.$route.query.company ? this.$route.query.company : ''
          this.filter.role = this.$route.query.role ? this.$route.query.role : ''
          this.filter.source = this.$route.query.source ? this.$route.query.source : ''
          this.filter.jobId = this.$route.query.jobId ? this.$route.query.jobId : ''
          this.filter.excludeCompany = this.$route.query.excludeCompany ? this.$route.query.excludeCompany : ''
          //this.filter.isBoolean = this.$route.query.isBoolean ? this.$route.query.isBoolean : ''
          this.filter.booleanSearchString = this.$route.query.booleanSearchString ? this.$route.query.booleanSearchString : ''
        
          this.filter.selected = [...new Set(this.filter.selected)]
          //this.selected = [...new Set(this.selected)];
          this.getRecentSearches();
          this.getSavedSearches();
          
          if(this.$route.query.selected) {
            this.advancedSearch()
          }
        //this.selected = this.filter.selected
        // this.filter = {
        //     minCTC: this.filter.minCTC,
        //     maxCTC: this.filter.maxCTC,
        //     minExp: this.filter.minExp,
        //     maxExp: this.filter.maxExp,
        //     excludeCompany: this.filter.excludeCompany,
        //     locations: this.filter.locations,
        //     genders: this.filter.company,
        //     qualifications: this.filter.qualifications,
        //     noticePeriod: this.filter.noticePeriod,
        //     company: this.filter.company,
        //     role: this.filter.role,
        // }
        // this.isBoolean = this.searchFilters.isBoolean
        // this.booleanSearchString = this.searchFilters.booleanSearchString

      }
      
      

  },
  methods: {
    selectAll() {
      this.selectedCandidates = this.candidates.map(candidate => candidate._source.id);
      console.log(this.selectedCandidates)
    },
    deselectAll() {
      this.selectedCandidates = [];
      console.log(this.selectedCandidates)
    },
    toggleSelection(item) {
        console.log('Clicked',item, this.selectedCandidates)
    },
    changePage(newPage) {
      // Update the current page
      this.filter.currentPage = newPage;
      this.elasticSearch(this.searchQuery)
      console.log('page changed to: ',this.filter.currentPage)
    },
    searchDB() {
        this.loading = true
        this.candidates = null
        this.currentPage = 1
        this.totalCount = 0
        this.advancedSearch()
    },
    // checkForComma(event) {
    //   if (event.key === ',') {
    //     // Prevent the comma from being added to the input
    //     event.preventDefault();
        
    //     // Add the current input text to the badges array
    //     this.badges.push(this.inputText.trim());
        
    //     // Clear the input
    //     this.inputText = '';
    //   }
    // },
    toggleFavourite(keyword) {
      const option = this.filter.selected.find(opt => opt.keyword === keyword);
      this.skillOptions = [...new Set(this.skillOptions)]
      this.filter.selected = [...new Set(this.filter.selected)]
      if (option) {
        option.isMandatory =! option.isMandatory;
        //const el_m = Array.from(document.querySelectorAll('span.vs__selected'))
        //    .find(el => el.textContent === keyword);
        if(option.isMandatory) {
            option.isExcluded = false
            // el_m.classList.remove('vs__selected')
            // el_m.classList.add('yellow')
        } //else {
        //     el_m.classList.remove('yellow')
        //     el_m.classList.add('green')
        // }
      }
    },
    toggleExclude(keyword) {
      const option = this.filter.selected.find(opt => opt.keyword === keyword);
      this.skillOptions = [...new Set(this.skillOptions)]
      this.filter.selected = [...new Set(this.filter.selected)]
    //   const el_m = Array.from(document.querySelectorAll('span.vs__selected'))
    //         .find(el => el.textContent === keyword);
      if (option) {
        option.isExcluded =!option.isExcluded;
        if(option.isExcluded) {
            option.isMandatory = false
            // el_m.classList.remove('vs__selected')
            // el_m.classList.add('red')
            
         } //else {
        //     el_m.classList.remove('red')
        //     el_m.classList.add('green')
        // }
      }
    },
    
    advancedSearch() {
        console.log('checking search query: ',this.filter.jobId, this.filter.jobId.includes('SHJ'), this.filter.selected,this.searchQuery.filter)
        if(!this.filter.jobId.includes('SHJ') || this.filter.selected.length === 0) {
            alert("Please enter the job id & atleast one keyword")
            return
        }
        console.log(this.filter.selected)
        this.candidates = []
        this.paginatedCandidates = []
        this.loading = true
        //let query = null


         let newFilter = {}
        // this.filter = {}
        // this.filter = {
        //     minCTC: newFilter.minCTC,
        //     maxCTC: newFilter.maxCTC,
        //     minExp: newFilter.minExp,
        //     maxExp: newFilter.maxExp,
        //     excludeCompany: newFilter.excludeCompany,
        //     locations: newFilter.locations,
        //     genders: newFilter.company,
        //     qualifications: newFilter.qualifications,
        //     noticePeriod: newFilter.noticePeriod,
        //     company: newFilter.company,
        //     role: newFilter.role,
        // }
        //f(this.filter.minExp === "0" || this.filter.minCTC === "0") {
            
        //}
        // let searchQuery = {}
        if(!this.isBoolean) {
            //query = this.buildKeywordSearchString(this.selected)
            //console.log('keyword search String', query)

            //const newFilter = {}
            //this.filter = {}
            newFilter = {
                minCTC: this.filter.minCTC ? parseFloat(this.filter.minCTC) : null,
                maxCTC: this.filter.maxCTC ? parseFloat(this.filter.maxCTC) : null,
                minExp: this.filter.minExp ? parseFloat(this.filter.minExp) : null,
                maxExp: this.filter.maxExp ? parseFloat(this.filter.maxExp) :  null,
                excludeCompany: this.filter.excludeCompany ? this.filter.excludeCompany.split(',') : null,
                locations: this.filter.locations ? this.filter.locations : null,
                genders: this.filter.genders ? this.filter.genders : null,
                qualifications: this.filter.qualifications ? this.filter.qualifications : null,
                noticePeriod: this.filter.noticePeriod ? this.filter.noticePeriod : null,
                company: this.filter.company ? this.filter.company : null,
                role: this.filter.role ? this.filter.role : null,
                jobId: this.filter.jobId ? this.filter.jobId : null,
                source: this.filter.source ? this.filter.source : null
                
            }
            newFilter.minExp === "0" ? 0 : parseFloat(newFilter.minExp)
            newFilter.minCTC === "0" ? 0 : parseFloat(newFilter.minCTC)
            // code to exclude companies 
            // if(this.excludeCompany) {
            //     const companies = this.excludeCompany.split(',')
            //     companies.forEach(item => {
            //         const exclude = {
            //             "keyword": item,
            //             "isMandatory": false,
            //             "isExcluded": true
            //         }
            //         this.filter.selected.push(exclude)
            //     })
            // }
            this.filter.selected = [...new Set(this.filter.selected)]

            this.searchQuery = {
                "query": this.filter.selected,
                "filter": newFilter,
                "useFuzzy" : false
            }

            this.elasticSearch(this.searchQuery)

            console.log('search query:', this.searchQuery)
        }
        
    },
    getRecentSearches() {
        searchesService.getRecentSearches(this.user).then(res => {
            console.log('recent Searches', res)
            this.recentSearches = res.data
            // this.recentSearches.forEach(search =>{
            //     const q = JSON.parse(search.search_query)
            //     console.log('query: ', q)
            // })

        })
    },
    getSavedSearches() {
        searchesService.getSearches(this.user).then(res => {
            console.log('saved Searches', res)
            this.savedSearches = res.data;
            //console.log('in saved searches: ',this.savedSearches)
            this.skillOptions = res.options[0].json_agg;
            //console.log('in skill options: ',this.skillOptions)
            this.skillOptions = Array.from(new Map(this.skillOptions.map(item => [item.keyword, item])).values());

            //this.savedSearches = this.savedSearches.filter(item => item.added_by === this.user )
        })
    },
    getSimilarSearches() {
        const keywords = this.filter.selected
            .map(item => item.keyword.toLowerCase());
            //console.log('keywords for similar search: ',keywords,keywords.toString())
            searchesService.getSimilarSearches(keywords.toString()).then(res =>{
                
                this.similarSearches = res.data
                //console.log('similar Search: ', this.similarSearches)
            })

    },
    elasticSearch(searchQuery) {
        elasticSearchService.search(searchQuery, this.filter.currentPage, this.filter.perPage).then(res => {
                console.log('elastic search result: ', res)
                if(res.status === "OK") {
                    this.error = null
                    this.totalCount = res.data.total
                    if(this.totalCount > 0) {
                        //this.candidates = res.data.data
                        //console.log('')
                        //this.candidates = Array.from(new Map(this.candidates.map(item => [item._source.id, item])).values());
                        this.candidates = res.data.data.map(candidate => {
                            // Add 'showContact' property to each candidate
                            return { ...candidate, showContact: false };
                        });
                        this.candidates = this.getUniqueCandidates(this.candidates)

                        console.log('count: ', this.totalCount)
                        
                        console.log('candidates result: ', this.candidates)
                        
                        this.getJob();
                        this.getRecentSearches();
                        this.getSimilarSearches();
                        this.loading = false
                        //this.matchSearchToJob()
                    } else {
                        this.error = "No Candidates found for Selected Criteria !!!"
                    }
                    if(this.filter.currentPage === 1) {
                        const saveSearch = {
                            search_query : JSON.stringify(searchQuery),
                            search_type : this.isBoolean ? 'Boolean' : 'String',
                            position: this.filter.jobId,
                            added_by: JSON.parse(localStorage.getItem('userData')).emp_id
                        }
                        console.log('save search', saveSearch)
                        searchesService.create(saveSearch).then(res => {
                            console.log(res)
                            if(!res) {
                                console.log('Search Save Failed', res)
                            }
                            if(res.status === "OK") {
                                console.log('Search Saved Successful')
                            } else {
                                console.log('Search Save Failed')
                            }
                            
                        })
                    }
                    
                } else if(res.status === 400) {
                    console.log('Error while connecting elastic search: ', res.message, res.error)
                    this.error = 'Error while connecting elastic search: '+ res.message + " \n" + res.error
                } else if(res.status === 500) {
                    console.log('Error while getting response: ', res.data.message)
                    this.error = 'Error while getting response: ' + res.data.message
                } else if(res.status === 403 && res.data.message === 'No token provided!') {
                    this.error = 'Session Expired, Please Login Again'
                    localStorage.clear();
                    this.$router.push({ name: "auth-login" });
                } else if (res == undefined) {
                    this.error = 'Some Error Occurred, Please Contact Admin if error perists !!!'
                }
            })
    },
    getUniqueCandidates(candidates) {
        const uniqueArray = candidates.sort((a, b) => new Date(b._source.cj_dt) - new Date(a._source.cj_dt));
            // Filter out duplicates and keep the latest
            const uniqueData = Array.from(candidates.reduce((map, item) => {
            return map.set(item._source.id, item);
        }, new Map()).values());
        return uniqueArray;

    },
    isValidBooleanSearch() {
        console.log(this.booleanSearchString)
        let stack = [];
        let words = this.booleanSearchString.match(/\b(AND|OR|NOT)\b|\(|\)|"[^"]+"|\w+/g);
        //console.log(words)
        if (!words) {
            return this.isValidBoolean = false;
        }

        let expectOperand = true;

        for (let word of words) {
            console.log('in for')
            if (word === '(') {
                console.log('in for if')
                stack.push('(');
                continue;
            } else if (word === ')') {
                console.log('in for if else if')
                if (stack.length === 0 || stack.pop() !== '(' || expectOperand) {
                    console.log('in for if else if if')
                    return this.isValidBoolean = false;
                }
            } else if (/\b(AND|OR|NOT)\b/.test(word)) {
                console.log('in for if else if else if')
                if (expectOperand) return this.isValidBoolean = false;
                expectOperand = true;
            } else {
                console.log('in for if else if else if else')
                if (!expectOperand) return this.isValidBoolean = false;
                expectOperand = false;
            }
        }
        this.isValidBoolean = stack.length === 0 && !expectOperand
        console.log(this.isValidBoolean)
        return this.isValidBoolean;
    },
    
    getJob(){
        console.log(this.filter.jobId)
        jobService.getJobByJobId(this.filter.jobId).then(res=> {
            console.log('job data', res)
            if (res.status === "OK") {
                this.job = res.data

                this.matchSearchToJob()
                // if(type === 'mass-mail') {
                //     this.generateMassMailerTemplate()
                // } 
                // // else if (type === 'assign') {
                // //     this.assignJob()
                // // }
                
            } else if ((res.status === 401 ) || (res.status === 403 )) {
            window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
            localStorage.clear();
            this.$router.push({ name: "auth-login" });
            } else if (res.status === 400) {
                this.jobNotFoundError = 'Job Not Found, Search Again !!!'
            } else {
                this.jobNotFoundError = 'Some Error Occurred: ' + JSON.stringify(res)
            }
        })
    },
    extractHighlightedWords(data) {
        const highlightedWords = {};

        // Regular expression to find words within <em> tags
        const regex = /<em>(.*?)<\/em>/g;

        for (const key of ['skills', 'cv_text', 'curr_position']) {
            if (data[key]) {
            highlightedWords[key] = [];

            data[key].forEach(text => {
                let match;
                while ((match = regex.exec(text)) !== null) {
                // Add the matched word to the array, avoiding duplicates
                if (!highlightedWords[key].includes(match[1])) {
                    highlightedWords[key].push(match[1]);
                }
                }
            });
            }
        }
        const mandatoryKeywords = this.filter.selected
            .filter(item => item.isMandatory)
            .map(item => item.keyword);
        
        
        mandatoryKeywords.forEach(key => {
            if(highlightedWords && highlightedWords.cv_text) {
                if(!highlightedWords.cv_text.filter(item => item === key)){
                    highlightedWords.cv_text.push(key)
                }
            }
            
        })
                

        return JSON.stringify(highlightedWords);
    },
    numDaysBetween(d1, d2) {
        var diff = Math.abs(d1.getTime() - d2.getTime());
        return diff / (1000 * 60 * 60 * 24);
    },
    assignJob() {
        if(this.selectedCandidates && this.selectedCandidates.length > 0) {
            const jid = this.job.id

            const userData = JSON.parse(localStorage.getItem("userData"));
            const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`;
            let canSource = 'ATS-CS'
            let sourcer = userData.emp_id
            let status = 'AssignedByATSSourcer'
            //let c = []
            const username = `${userData.first_name} ${userData.last_name}`
            // const userRole = JSON.parse(localStorage.getItem('userData')).roles[0]

            this.selectedCandidates.forEach(id => {
                console.log('emp_id', id)
                //c.push[id]
                const createdAt = this.candidates.filter(item => item._id == id)[0]._source.createdAt
                const now = new Date();
                const diff = this.numDaysBetween(now, new Date(createdAt))
                console.log('diff',diff)
                
                // if(diff > 5 ) {
                //     canSource = 'ATS'
                //     console.log('source diff greater',canSource, diff, createdAt)
                // } else {
                //     canSource = source
                //     console.log('source diff less',canSource, diff, createdAt)
                // }
                if(diff > 30 ) {
                    sourcer = 'ATS'
                    console.log('source diff greater',canSource, diff, createdAt)
                } else {
                    sourcer = sourcer
                    console.log('source diff less',canSource, diff, createdAt)
                }

                let data = {
                    job_id: jid,
                    candidate_id: [id],
                    candidateStatus: status,
                    source: canSource,
                    addedBy: user,
                    updatedBy: user,
                    sourcer: sourcer,
                    //recruiter: userData.emp_id
                }
                const jt =  {
                        title: `Candidate Id - ${id} - Assigned to the job with Status ${data.candidateStatus}`,
                        description: `CS-Assign via Candidate DB Search`, /// CS-Changed means candidate status changed
                        type: "success",
                        createdBy: username,
                        jobId: jid,
                        candidate_id: id,
                        candidateStatus: data.candidateStatus
                    }
                data.jt = jt
                
                console.log('assign to job ', data)
                jobService.assignCandidateToJob(data).then(res => {
                    
                    if(res.status === "OK") {
                    console.log('Assign to Job', id, jid, data, res)

                    this.$toast({
                        component: ToastificationContent,
                        props: {
                        title: 'Candidate Added to Job, Please Fill in rest details to share Profile',
                        icon: 'EditIcon',
                        variant: 'success',
                        timeout: 10000,
                        },
                    })
                    
                    } else if (res.status === 410 || res.message === 'Candidate already exist in Current Job') {
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                        title: 'Failed! Candidate already exist in Job !!!',
                        icon: 'EditIcon',
                        variant: 'danger',
                        timeout: 5000,
                        },
                    })
                    } else if ((res.status === 401 ) || (res.status === 403 )) {
            
                        window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
                        
                        localStorage.clear();
                        this.$router.push({ name: "auth-login" });
                    } else {
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                        title: 'Candidate Add to Job Failed !!!',
                        icon: 'EditIcon',
                        variant: 'danger',
                        timeout: 5000,
                        },
                    })
                    }
                })
            })
        } else {
            alert('No Candidate Selected!!!')
        }
    },
    generateMassMailerTemplate(can_id,CANDIDATE_FNAME,CANDIDATE_MOBILE) {

        const userData = JSON.parse(localStorage.getItem("userData"));

        const recruiter = `${userData.first_name} ${userData.last_name}`
        const recruiterEmail = userData.email
        const recruiterContactNo = userData.contact_no
        const sender_id = userData.emp_id
        //const job_id = null
        const candidate_id = can_id
        

        const hrefInterested = `https://ats.sattvahuman.in/api/mass-mailer/ext/${this.job.id}/${candidate_id}/${sender_id}?response=Interested&source=ATS`
        const hrefNLFChange = `https://ats.sattvahuman.in/api/mass-mailer/ext/${this.job.id}/${candidate_id}/${sender_id}?response=Not Looking For Change&source=ATS`
        const hrefNR = `https://ats.sattvahuman.in/api/mass-mailer/ext/${this.job.id}/${candidate_id}/${sender_id}?response=Not Relevant&source=ATS`

        
        this.massMailerTemplate =  `<p> Dear <b> {{ CANDIDATE_FNAME }} </b>,</br>

        <p>Congratulation !</p> </br>

        <p>We would like to inform you that your profile matches one of our ongoing requirements and we are glad to proceed with your candidature if you are interested to pursue the same. </p>
        <p>Position Name : <b> ${this.job.position_name} </b></p>
        <p>Locations : <b> ${this.job.locations}</b></p>
        </br>

        <p>  Request you to go through the JD & let us know if you are interested for this role.</p>
        </br>
        <div style="display: flex; flex-wrap: wrap; justify-content: flex-start; align-items: center; ">

        <a href="${hrefInterested}"><button style="background-color: #00AC99; border: none; color: white; padding: 10px 16px; font-weight: 500; text-align: center; text-decoration: none; display: inline-block; font-size: 14px;margin: 5px;"> Interested </button></a>
        <a href="${hrefNLFChange}"><button style="background-color: #00AC99; border: none; color: white; padding: 10px 16px; font-weight: 500; text-align: center; text-decoration: none; display: inline-block; font-size: 14px;margin: 5px;"> Not Looking for Change </button></a>
        <a href="${hrefNR}"><button style="background-color: #00AC99; border: none; color: white; padding: 10px 16px; font-weight: 500; text-align: center; text-decoration: none; display: inline-block; font-size: 14px;margin: 5px;"> Not Relevant </button></a>

        </div>
        </br>
        <p>Click Reply to directly contact with Recruiter or contact them : </p>
        <p> <b> ${recruiter}</b> (assigned to you) at <b>${recruiterEmail}</b>/<b>${recruiterContactNo}</b>  </p>       
        <a href="mailto:${recruiterEmail}?subject=Candidate Reply : Knock Knock! {{ CANDIDATE_FNAME }}! Your profile is a match for the role we are hiring!&body=

        --------------------------------------------------------------------------------------------
        Position Details: 
        Position Name : ${this.job.position_name}
        Locations : ${this.job.locations}"><button style="background-color: #00AC99; border: none; color: white; padding: 10px 16px; text-align: center; text-decoration: none; display: inline-block; font-size: 14px; margin: 5px;"> Reply </button></a>
        </br>
        <p> If you are Interested, our recruitment team will get in touch with you at your mobile number : <b> {{ CANDIDATE MOBILE }}</b>.
        </br>
        <p> All the Best!</p> <p>Team Sattva</p>`
        console.log(this.massMailerTemplate)
        return this.massMailerTemplate.replaceAll('{{ CANDIDATE_FNAME }}', CANDIDATE_FNAME).replace('{{ CANDIDATE MOBILE }}',CANDIDATE_MOBILE)
    },
    sendMassMail() {
        const userData = JSON.parse(localStorage.getItem("userData"));
        let i = 0
        const mailer_id = Date.now()
        this.selectedCandidates.forEach(can => {

            const candidate = this.candidates.filter(item => item._source.id === can)[0]
            console.log('in mail generate can data: ', candidate)
            let mail_body = null
            mail_body = this.generateMassMailerTemplate(candidate._source.id, candidate._source.first_name + ' ' + candidate._source.last_name, candidate._source.email)
            console.log('in mail generate mail body: ', mail_body)
            const recruiter = `${userData.first_name} ${userData.last_name}`
            const recruiterEmail = userData.email
            const sender_id = userData.emp_id
            
            let mailData = {
                to: candidate._source.email,
                //to: "ritesh@sattvahuman.com",
                cc: '',
                fromName: recruiter,
                fromMail: recruiterEmail,
                subject: `Knock Knock! ${candidate._source.first_name} ${candidate._source.last_name}! We are hiring!!!!`,
                html: mail_body,
                filename: this.job.attachments,
                cv_filename: '',
                data : {
                      sender_id: sender_id,
                      candidate_id: candidate._source.id,
                      job_id: this.job.id,
                      mailer_id: 'ATSMassMailer_' + mailer_id
                    }
            }
            console.log('in mail send mail data: ', mailData)
            setTimeout(() => {
            if(mailData) {
                mailService.massMail(mailData).then(res => {
                  console.log("in mail Send", res)
                  let data = {}
                  if (res.status === "OK") {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Mail Send to candidate Successful',
                        icon: 'MailIcon',
                        variant: 'success',
                        timeout: 3000,
                      }
                    })
                  } else if (res.status === 502) {
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Mail Send to candidate Failed',
                          icon: 'MailIcon',
                          variant: 'danger',
                          timeout: 3000,
                        }
                      })
                  } else if ((res.status === 401 ) || (res.status === 403 )) {
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Login Session Expired, Login Again',
                          icon: 'MailIcon',
                          variant: 'danger',
                          timeout: 3000,
                        }
                      })
                      window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
                      localStorage.clear();
                      this.$router.push({ name: "auth-login" });
                  } else if (res.status === 500) {
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Some Error occurred' + res.error,
                          icon: 'MailIcon',
                          variant: 'danger',
                        }
                      })
                  } else {                    
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Some Error occurred' + res,
                          icon: 'MailIcon',
                          variant: 'danger',
                        }
                    })  
                  }
                })           
                console.log('hi', i, Date.now())
            }
        },i * 1000)
        i = i + 1
        })

        
    },
    fillSearch(query) {
        let search = JSON.parse(query)
        console.log(search)
        this.filter.selected = search.query
        //this.filter.minExp = search.filter.minExp ? search.filter.minExp : ''
        this.filter.maxExp = search.filter.maxExp ? search.filter.maxExp : ''
        //this.filter.minCTC = search.filter.minCTC ? search.filter.minCTC : ''
        this.filter.maxCTC = search.filter.maxCTC ? search.filter.maxCTC : ''
        this.filter.noticePeriod = search.filter.noticePeriod ? search.filter.noticePeriod : ''
        this.filter.locations = search.filter.locations ? search.filter.locations : ''
        this.filter.qualifications = search.filter.qualifications ? search.filter.qualifications : ''
        this.filter.genders = search.filter.genders ? search.filter.genders : ''
        this.filter.company = search.filter.company ? search.filter.company : ''
        this.filter.role = search.filter.role ? search.filter.role : ''
        this.filter.excludeCompany = search.filter.excludeCompany ? search.filter.excludeCompany.toString() : ''
        //this.filter.isBoolean = search.filter.isBoolean ? search.filter.isBoolean : ''
        this.filter.booleanSearchString = search.filter.booleanSearchString ? search.filter.booleanSearchString : ''
        console.log('filter min search: ', search.filter.minCTC, typeof search.filter.minCTC)
        //console.log('filter min filter b4: ', this.filter.minCTC, typeof this.filter.minCTC)
        this.filter.minExp = search.filter.minExp === null ? null : search.filter.minExp === 0 ? "0" : search.filter.minExp
        this.filter.minCTC = search.filter.minCTC === null ? null : search.filter.minCTC === 0 ? "0" : search.filter.minCTC
        this.filter.jobId = search.filter.jobId ? search.filter.jobId : ''
        this.filter.source = search.filter.source ? search.filter.source : ''

        console.log('filter min filter after: ', this.filter.minCTC, typeof this.filter.minCTC)
        
    },
    clearFilter() {
        this.filter.selected = null
        this.filter.minExp = null
        this.filter.maxExp = null
        this.filter.minCTC = null
        this.filter.maxCTC = null
        this.filter.noticePeriod = null
        this.filter.locations = null
        this.filter.qualifications = null
        this.filter.genders = null
        this.filter.company = null
        this.filter.role = null
        this.filter.excludeCompany = null
        //this.filter.isBoolean = null
        this.filter.booleanSearchString = null
        
    },
    computeSearchQuery(query) {
        const searchQueryText = JSON.parse(query);
        let mandatoryKeywords = [];
        let optionalKeywords = [];
        let excludedKeywords = [];
    
        searchQueryText.query.forEach(item => {
            
        if (item.isMandatory) {
            mandatoryKeywords.push(item.keyword);
        } else if (!item.isExcluded) {
            optionalKeywords.push(item.keyword);
        } else {
            excludedKeywords.push(item.keyword);
        }
        });

        const filterStrings = Object.entries(searchQueryText.filter).map(([key, value]) => {
        return `${key}: ${Array.isArray(value) ? value.join(', ') : value === null ? '' : value}`;
        });

        const formattedString = `<b>${mandatoryKeywords.join(', ')}</b> |  ${optionalKeywords.join(', ')} |  <del>${excludedKeywords.join(', ')}</del> |  ${filterStrings.join(', ')}`;

        //console.log(formattedString);
        return formattedString;
    },
    matchSearchToJob() {
        const keywords = this.filter.selected
            .map(item => item.keyword.toLowerCase());
        let matchCount = 0
        let keys = 0 
        console.log('keywords in match', keywords)
        const jd = this.job.job_description.toLowerCase()
        const skills = this.job.desired_skills.toLowerCase()

        keywords.forEach(keyword => {
            keys++;
            if(keyword.includes('and') || keyword.includes('&')) {
                if(keyword.includes('and')) {
                    keywords.push(keyword.replace('and','&'))
                }
                if(keyword.includes('&')) {
                    keywords.push(keyword.replace('&','and'))
                }
            }
        })   
        keywords.forEach(keyword => {
            if(jd.includes(keyword.replaceAll('"','')) || skills.includes(keyword.replaceAll('"',''))) {
                matchCount++
            }
        })    
        this.keywordsMatchCount = matchCount
        this.jobSearchMatchPercent = Math.round(matchCount/keys*100)
        console.log('matchCount score %: ', this.jobSearchMatchPercent)
    },
    previewCV(cvFile) {
        
        const key = cvFile.replace("/","%2F")
        const temp = key.split(".");
        const extension = temp[temp.length - 1]; // Or parts.pop();

        if(extension === 'pdf') {
            this.pdf = true
            this.docx = false
            this.doc = false
            this.otherDoc = false
            this.rtf = false
          } else if (extension === 'docx'){
            this.pdf = false
            this.docx = true
            this.doc = false
            this.otherDoc = false
            this.rtf = false
          } else if (extension === 'doc'){
            this.pdf = false
            this.docx = false
            this.doc = true
            this.otherDoc = false
            this.rtf = false
          }else if (extension === 'rtf'){
            this.pdf = false
            this.docx = false
            this.doc = false
            this.rtf = true
            this.otherDoc = false
          } else if (extension !== 'docx' || extension !== 'doc' || extension !== 'pdf' || extension !== 'rtf') {
            this.pdf = false
            this.docx = false
            this.doc = false
            this.rtf = false
            this.otherDoc = true
          } 
          
          jobService.getFile(key)
            .then(res => {
              //console.log(res)
              this.dlink = res.file;
              var encodedUrl = encodeURIComponent(res.file);
              this.glink = //'https://ats.sattvahuman.in/download/' + response.data.cv_path
                "https://docs.google.com/viewer?url=" + encodedUrl + "&embedded=true";

              this.mlink = "https://view.officeapps.live.com/op/view.aspx?src=" + encodedUrl
              console.log(this.mlink)
              this.dlink = res.file;

          });
          if(this.pdf) {
            jobService.getFileBase64(key)
              .then(res => {
                ////console.log(res)
                const base64 = res.file;
                //var encodedUrl = encodeURIComponent(res.file);
                this.blink = "data:application/pdf;base64," + base64
                
            }); 
            
          }
          this.$refs["cv-preview-modal"].show();
    },
    openMassMailerModal() {
        
        this.$refs["modal-mass-mailer"].show();
        this.generateMassMailerTemplate(null,null,null);
        
    },
    shareProfile(cid, jid) {

        this.selectedCandidates.push(cid)
        this.assignJob()
        // Share Profile code goes here, need to get JD attachment details
        //this.$router.push({ path: '/apps/view-job/' + data.job_id }).catch(() => {})
        // :to="{
        //                       name: 'apps-candidates-edit', 
        //                       params: { id: candidateData.id, jobId: jobId },
        //                       query: {  position_name: position_name,
        //                                 client: client,
        //                                 attachments: attachments,
        //                                 rec_name: rec_name,
        //                                 locations: locations,
        //                                 // min_ctc: jobData.min_ctc,
        //                                 // max_ctc: jobData.max_ctc,
        //                                 // min_exp: jobData.min_exp,
        //                                 // max_exp: jobData.max_exp,
        //                                 // notice_period: jobData.notice_period,
        //                                 interested: 'YES'
        //                         }
        //                     }"
        console.log('in share profile', cid, jid, this.job)
        this.$router.push({path: '/apps/candidates/edit/' + cid + '/' + jid, 
        query:{
            position_name: this.job.position_name,
            client: JSON.parse(this.job.client)[0].title,
            attachments: this.job.attachments,
            rec_name: this.user,
            locations: this.job.locations,
            interested: 'YES',
            src: 'BooleanSearch',
            account_mgr_id: JSON.parse(this.job.account_mgr)[0].emp_id,
            account_mgr: JSON.parse(this.job.account_mgr)[0].title,
            min_exp: parseFloat(this.job.min_exp),
            max_exp: parseFloat(this.job.max_exp),
            min_ctc: parseFloat(this.job.min_ctc),
            max_ctc: parseFloat(this.job.max_ctc),
            notice_period: parseInt(this.job.notice_period),
            job_id: this.jobId,
            position_type: this.job.type
        }})
        

    },
    saveSearch() {
        if(this.searchQuery && this.searchQuery.query.length > 0 && this.searchTitle) {
            const saveSearch = {
                search_query : JSON.stringify(this.searchQuery),
                search_type : this.isBoolean ? 'Boolean' : 'String',
                position: this.filter.jobId,
                added_by: JSON.parse(localStorage.getItem('userData')).emp_id,
                saved: true,
                title: this.searchTitle
            }
            console.log('save search', saveSearch)
            searchesService.create(saveSearch).then(res => {
                console.log(res)
                if(!res) {
                    console.log('Search Save Failed', res)
                }
                if(res.status === "OK") {
                    console.log('Search Saved Successful')
                } else {
                    console.log('Search Save Failed')
                }
                
            })
        } else {
            alert("Please make sure search has a Search Result and Search Title.")
        }
        
    },
    // updateAsViewed(cid,jid) {

    // },
    getContactNumber(candidate) {
        // const can = this.candidates.filter(item => item._id === id)[0]._source.contact_no
        candidate.showContact = !candidate.showContact
        const userData = JSON.parse(localStorage.getItem("userData"));
        
        const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`;
        const data = {
            viewed: {
                job_id: this.job.id,
                accessed_by: user,
                accessed_on: new Date()
            }
        } 
        CandidateService.updateCandidateViewed(candidate._source.id,data).then(res => {
            console.log('candidate accessed ',res)
            if(res.status === "OK" && res) {
                console.log('candidate accessed added')
            } else {
                console.log('candidate accessed add failed')
            }
        })

        // elasticSearchService.createHistory(data).then(res => {
        //     console.log('candidate access ',res)
        //     if(res.status === "OK" && res) {
        //         console.log('candidate access added')
        //     } else {
        //         console.log('candidate access add failed')
        //     }

        // })
        // CandidateService.assignCandidateToJob(data).then(res => {
        //         console.log(res.data);
        //         if (res.status === "OK") {
                
        //             const timelineData = {
        //                 title: `Candidate - ${this.candidate_id} Status Changes to ${this.statusCSelected}`,
        //                 description: `CS-Changed`, /// CS-Changed means candidate status changed
        //                 type: "success",
        //                 createdBy: username,
        //                 jobId: this.job.id,
        //                 candidate_id: this.candidate_id,
        //                 candidateStatus: this.statusCSelected,
                        
        //             }
        //             jobTimelineService.create(timelineData).then(res => {
        //                 console.log('timeline Updated')
        //                 this.statusCSelected = null
        //                 this.candidate_id = null
        //                 this.NI_NR_comment = null
        //                 this.NI_Reason_Selected = null
        //                 this.error_NI_NR_comment = null
        //                 this.NI = true
        //                 this.NA_comment = null
        //                 this.error_NA_comment = null
        //                 this.isValid = null
        //             })
                
        //             this.$toast({
        //                 component: ToastificationContent,
        //                 props: {
        //                 title: "Candidate Status Updated",
        //                 icon: "EditIcon",
        //                 variant: "success",
        //                 },
        //             });
                
        //         } else if ((res.status === 401 ) || (res.status === 403 )) {
        //             window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
        //             localStorage.clear();
        //             this.$router.push({ name: "auth-login" });
        //         } else {
        //             this.$toast({
        //                 component: ToastificationContent,
        //                 props: {
        //                 title: "Candidate Status Update Failed",
        //                 icon: "EditIcon",
        //                 variant: "danger",
        //                 },
        //             });
        //         }
        //     }
        // )
    },
    shareSearch(search) {
        alert('Share search logic yet to be build, till then you click fill this search and share browser URL to your Team!!!')
    },
    showNINRModal(val,cid) {
      this.candidate_id = cid
      console.log('candiadte id: ', this.candidate_id)
      if (val === 'nr') {
        this.NI = false
      } else {
        this.NI = true
      }
      this.$refs["modal-ni-nr-reason"].show();
    },
    showNotAnsweredModal(cid) {
      this.candidate_id = cid
      console.log('candiadte id: ', this.candidate_id)
      this.$refs["modal-na-status"].show();
    },
    updateCandidateNINRReason() {
      if (this.NI) {
        this.statusCSelected = 'Not Interested'
        console.log('NI NR reason & comment', this.NI_Reason_Selected, this.NI_NR_comment)
        if(this.NI_Reason_Selected !== '' & this.NI_NR_comment !== null) {
            this.isValid = true
            this.updateCandidateStatus(this.candidate_id)
        } else {
            this.isValid = false
            console.log('inside invalid not interetes')
            this.$toast({
                        component: ToastificationContent,
                        props: {
                        title: "Failed!!! Comment or Reason Missing",
                        icon: "EditIcon",
                        variant: "danger",
                        },
            });
          this.error_NI_NR_comment = 'Reason & comment is mandatory'
          this.$refs["modal-ni-nr-reason"].show();
        }
      } else if (!this.NI) {
        this.statusCSelected = 'Not Relevant'
        if(this.NI_NR_comment !== null) {
            this.isValid = true
            this.updateCandidateStatus(this.candidate_id)
        } else {
            this.isValid = false
            console.log('inside invalid not relevant')
            this.$toast({
                        component: ToastificationContent,
                        props: {
                        title: "Failed!!! Comment or Reason Missing",
                        icon: "EditIcon",
                        variant: "danger",
                        },
            });
          this.error_NI_NR_comment = 'Comment is mandatory'
          this.$refs["modal-ni-nr-reason"].show();
        }
      }
    },
    updateNotAnswered(cid) {
        this.candidate_id = cid
      if(this.NA_Reason_Selected.title && this.NA_comment !== null) {
        console.log('inside valid not answered', this.candidate_id)
        this.isLoggedIn()
      //console.log('called not answered', this.NA_Reason_Selected.title)
        this.statusCSelected = this.NA_Reason_Selected.title
        this.candidate_id = this.id
        this.isValid = true
        this.updateCandidateStatus(cid)
      } else {
        this.isValid = false
        console.log('inside invalid not answered')
        this.$toast({
                    component: ToastificationContent,
                    props: {
                    title: "Failed!!! Comment or Status Missing",
                    icon: "EditIcon",
                    variant: "danger",
                    },
        });
      } 
      
    },
    isLoggedIn() {
      const expireIn = localStorage.getItem('expireIn')
      if (Math.floor(Date.now() / 1000 > expireIn)) {
          window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
          ////console.log("called logout")
          localStorage.clear();
          this.$router.push({ name: "auth-login" });
      }
    },
    // filterAging() {
    //     console.log('Filter last days data: ',this.agingSelected)
    // },
    filterAging() {
        const currentDate = new Date();
        const pastDate = new Date(currentDate.getTime() - (this.agingSelected * 24 * 60 * 60 * 1000));
        console.log('Filter last days data: ',this.agingSelected)
        
        // const data = this.candidates
        //     .filter(candidate => {
        //         // Convert createdAt string to Date object
        //         const createdAtDate = new Date(candidate._source.createdAt);
        //         console.log('In Filter createdAT value: ',createdAtDate, pastDate)
        //         // Check if createdAt is within the specified range
        //         return createdAtDate >= pastDate;
        //     })
        //     .sort((a, b) => {
        //         // Convert createdAt strings to Date objects for sorting
        //         const dateA = new Date(a.createdAt);
        //         const dateB = new Date(b.createdAt);
        //         // Sort in descending order (newest first)
        //         return dateB - dateA;
        //     });
        // console.log('filtered data: ',data)

        // this.candidates = this.candidates
        //     .filter(candidate => {
        //         // Convert createdAt string to Date object
        //         const createdAtDate = new Date(candidate.createdAt);
        //         // Check if createdAt is within the specified range
        //         return createdAtDate >= pastDate;
        //     })
        //     .sort((a, b) => {
        //         // Convert createdAt strings to Date objects for sorting
        //         const dateA = new Date(a.createdAt);
        //         const dateB = new Date(b.createdAt);
        //         // Sort in descending order (newest first)
        //         return dateB - dateA;
        //     });
            //console.log('Filtered candidates last days data: ',this.agingSelected, this.candidates.length)
        return this.candidates
            .filter(candidate => {
                    // Convert createdAt string to Date object
                    const createdAtDate = new Date(candidate._source.createdAt);
                    // Check if createdAt is within the specified range
                    return createdAtDate >= pastDate;
                })
                .sort((a, b) => {
                    // Convert createdAt strings to Date objects for sorting
                    const dateA = new Date(a.createdAt);
                    const dateB = new Date(b.createdAt);
                    // Sort in descending order (newest first)
                    return dateB - dateA;
                });
            
    },
    updateCandidateStatus(cid) {
        this.isLoggedIn()
        if (!this.statusCSelected) {
            this.error_status = 'Please Select Status!!'
            
            this.$toast({
                    component: ToastificationContent,
                    props: {
                    title: "Failed!!! Status Not Selected",
                    icon: "EditIcon",
                    variant: "danger",
                    },
            });
            return
        }
        this.candidate_id = cid
        console.log(this.statusCSelected, this.candidate_id);
        const userData = JSON.parse(localStorage.getItem("userData"));
        
        const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`;
        const username = `${userData.first_name} ${userData.last_name}`
        //const useremail = userData.email
        //const p_mgr = this.recruiters.filter(item => item.emp_id === userData.mgr_id)
        const mgr = this.allUsers.filter(item => item.emp_id === userData.mgr_id)
        const p_mgr_id = mgr[0].manager
        let data = {}

        let c = [];
            c.push(this.candidate_id)
        
        if(this.statusCSelected === 'Not Interested'){
            
            data = {
                job_id: this.job.id,
                candidate_id: c,
                candidateStatus: this.statusCSelected,
                addedBy: user,
                updatedBy: user,
                reason: this.NI_Reason_Selected.title,
                comment: this.NI_NR_comment,
                recruiter: userData.emp_id,
                sourcer: userData.emp_id,
                mgr_id: userData.mgr_id,
                p_mgr_id: p_mgr_id,
                // "Manager Name": this.userRole === 'TALENT-ADVISOR-SOURCER' ? mgr[0].title.toUpperCase() : username.toUpperCase(),
                "Manager Name": this.$can('read','talent_acquisition') ? mgr[0].title.toUpperCase() : username.toUpperCase(),
                "Employee Name": username.toUpperCase(),
            };
        } else if(this.statusCSelected === 'Not Relevant'){
            data = {
                job_id: this.job.id,
                candidate_id: c,
                candidateStatus: this.statusCSelected,
                addedBy: user,
                updatedBy: user,
                comment: this.NI_NR_comment,
                recruiter: userData.emp_id,
                sourcer: userData.emp_id,
                mgr_id: userData.mgr_id,
                p_mgr_id: p_mgr_id,
                // "Manager Name": this.userRole === 'TALENT-ADVISOR-SOURCER' ? mgr[0].title.toUpperCase() : username.toUpperCase(),
                "Manager Name": this.$can('read','talent_acquisition') ? mgr[0].title.toUpperCase() : username.toUpperCase(),
                "Employee Name": username.toUpperCase(),
            };
        } else if(this.statusCSelected === 'Not Answered' || this.statusCSelected === 'Not Reachable' || this.statusCSelected === 'Wrong Number' || this.statusCSelected === 'Call Back'){
            console.log('inside NA', this.statusCSelected, this.NA_comment, this.candidate_id)
            data = {
                job_id: this.job.id,
                candidate_id: c,
                candidateStatus: this.statusCSelected,
                addedBy: user,
                updatedBy: user,
                comment: this.NA_comment,
                recruiter: userData.emp_id,
                sourcer: userData.emp_id,
                mgr_id: userData.mgr_id,
                p_mgr_id: p_mgr_id,
                // "Manager Name": this.userRole === 'TALENT-ADVISOR-SOURCER' ? mgr[0].title.toUpperCase() : username.toUpperCase(),
                "Manager Name": this.$can('read','talent_acquisition') ? mgr[0].title.toUpperCase() : username.toUpperCase(),
                "Employee Name": username.toUpperCase(),
            };
        } 

        
        //console.log('status',status) 
        //console.log('check if update allowed',this.selectionDate, this.offeredDate, this.joiningDate, this.error, this.isvalid)
        if(this.isValid === true) {
            
            jobService.assignCandidateToJob(data).then(res => {
                console.log(res.data);
                if (res.status === "OK") {
                
                    const timelineData = {
                        title: `Candidate - ${this.candidate_id} Status Changes to ${this.statusCSelected}`,
                        description: `CS-Changed`, /// CS-Changed means candidate status changed
                        type: "success",
                        createdBy: username,
                        jobId: this.job.id,
                        action: 'candidate-db',
                        candidate_id: this.candidate_id,
                        candidateStatus: this.statusCSelected,
                        
                    }
                    jobTimelineService.create(timelineData).then(res => {
                        console.log('timeline Updated')
                        this.statusCSelected = null
                        this.candidate_id = null
                        this.NI_NR_comment = null
                        this.NI_Reason_Selected = null
                        this.error_NI_NR_comment = null
                        this.NI = true
                        this.NA_comment = null
                        this.error_NA_comment = null
                        this.isValid = null
                    })
                
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                        title: "Candidate Status Updated",
                        icon: "EditIcon",
                        variant: "success",
                        },
                    });
                
                } else if ((res.status === 401 ) || (res.status === 403 )) {
                    window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
                    localStorage.clear();
                    this.$router.push({ name: "auth-login" });
                } else {
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                        title: "Candidate Status Update Failed",
                        icon: "EditIcon",
                        variant: "danger",
                        },
                    });
                }
            }
        );
        }  else {
        this.$toast({
                component: ToastificationContent,
                props: {
                title: "Failed!!! " + this.error,
                icon: "EditIcon",
                variant: "danger",
                },
            });
        }
    },
    // formatDateString(dateString) {
    //     const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        
    //     const date = new Date(dateString);
    //     const day = date.getUTCDate().toString().padStart(2, '0');
    //     const month = months[date.getUTCMonth()];
    //     const year = date.getUTCFullYear();
    //     const hours = date.getUTCHours().toString().padStart(2, '0');
    //     const minutes = date.getUTCMinutes().toString().padStart(2, '0');

    //     return `${day}-${month}-${year} ${hours}:${minutes}`;
    // },
    
    downloadExcel() {
      try {
        // Get candidates to export (either filtered or all)
        const candidatesToExport = this.displayedCandidates;

        // Transform candidates data for Excel
        const excelData = candidatesToExport.map(candidate => {
          const source = candidate._source;
          return {
            'Name': source.name || '',
            'Email': source.email || '',
            'Contact': source.contact_no || '',
            'Current Company': source.curr_company || '',
            'Current Position': source.curr_position || '',
            'Experience': source.exp || '',
            'Current CTC': source.ctc || '',
            'Expected CTC': source.exp_ctc || '',
            'Current Location': source.curr_location || '',
            'Preferred Location': source.pref_location || '',
            'Notice Period': source.notice_period || '',
            'Skills': source.skills || '',
            'Job Title': source.job_title || '',
            'Job ID': source.job_id || '',
            'Created At': source.createdAt || '',
            'Status': source.candidateStatus || ''
          };
        });

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(excelData);

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Candidates');

        // Generate Excel file
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        
        // Download file
        saveAs(blob, `Candidates_Export_${new Date().toISOString().slice(0,10)}.xlsx`);

        // Show success message
        this.$bvToast.toast('Excel file downloaded successfully', {
          title: 'Success',
          variant: 'success',
          solid: true
        });
      } catch (error) {
        console.error('Excel download error:', error);
        this.$bvToast.toast('Failed to download Excel file', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }
    },

    filterByJob(jobId) {
        console.log('filterByJob', jobId)
      if (jobId === 'all') {
        this.clearJobFilter();
        return;
      }

      
      console.log('candidates', this.candidates.length)
        this.candidates = this.candidates.filter(
          candidate => candidate._source.job_id == jobId
        );
        console.log('candidates', this.candidates.length)
    },

    clearJobFilter() {
      this.selectedJobFilter = null;
      this.filteredCandidates = [];
    },
    
  },
  mounted() {
    adminConfigService.getATSDropdownList().then(res => {
        if(res.status === 200) {
            this.sourceOptions = res.data.data.sourceList
            this.qualificationOptions = res.data.data.qualificationList
        }
    })
  }
  
}
</script>
<style lang="scss" >

//@import '@core/scss/vue/libs/vue-select.scss';
.card .card-header {
    padding: 0px !important;    
}
.btn-can-db {
    padding: 4px !important;
    margin: 4px;
    font-size: 14px;
}
.rounded-right {
  border-top-right-radius: 120px; /* Adjust the value for your desired roundness */
  border-bottom-right-radius: 120px; /* Adjust the value for your desired roundness */
}
.favourite {
  color: #00ac99    ;
}
.green {
    background-color: #26ff00;
}

.yellow {
    background-color: #fff200;
}
.red {
    background-color: #eb2424;
}
.list-group-item {
    padding: 0.15rem 0.25rem;
    background: none !important;
    border: none;
}
.v-select:not(.vs--single) .vs__selected {
    margin: 5px 2px 2px 5px;
}

[dir] .v-select:not(.vs--single) .vs__selected {
    border-radius: 3px;
    padding: 0 0.6em;
}

.v-select:not(.vs--single) .vs__selected {
    font-size: 0.9rem;
}
span.vs__selected {
    background-color: #ddddddc7;
    border: 0 solid #00ac99;
    border-radius: 0.357rem;
    margin: 4px 2px 0px 2px;
    padding: 0 0.25em;
}
// .vs__selected--neutral {
//     background-color: #ddddddc7;
//     border: 0 solid #00ac99;
//     border-radius: 0.357rem;
//     margin: 4px 2px 0px 2px;
//     padding: 0 0.25em;
// }
// .vs__selected--mandatory {
//     background-color: #00ac99;
//     border: 0 solid #00ac99;
//     border-radius: 0.357rem;
//     margin: 4px 2px 0px 2px;
//     padding: 0 0.25em;
// }
// .vs__selected--excluded {
//     background-color: #bf1307;
//     border: 0 solid #00ac99;
//     border-radius: 0.357rem;
//     margin: 4px 2px 0px 2px;
//     padding: 0 0.25em;
// }

// span.vs__selected {
//     color: #000;
// }

span.vs__selected {
    display: flex;
    align-items: center;
    color: #333;
    line-height: 1.8;
    z-index: 0;
}

.v-select, .v-select * {
    box-sizing: border-box;
}

.cursor-pointer {
  cursor: pointer;
}
</style>